<template>
	<!-- <content-head title="Home" /> -->
	<heading />
	<content class="">
		<div class="row">
			<!-- Loading Overlay for Modal Data -->
			<div v-if="loadModalData" class="loading-overlay">
				<div class="loading-spinner">
					<div class="spinner-border text-primary" role="status">
						<span class="visually-hidden">Loading ...</span>
					</div>
					<p class="mt-3">Loading Data ...</p>
				</div>
			</div>
			<div
				class="card custom-card bg-light col-xl-12 rounded-0 border-0 shadow"
			>
				<div class="row card-title pb-0 px-2 pt-2">
					<div class="col-12">
						<div
							class="page-title-box d-sm-flex align-items-center justify-content-between nunito-black"
						>
							<div class="page-title-left">
								<ol class="breadcrumb m-0">
									<li class="breadcrumb-item">
										<a href="">
											<span
												class="badge rounded-pill bg-green-custom text-white font-size-15"
												>&nbsp;&nbsp;&nbsp;<i
													class="nav-icon fas fa-handshake"
												></i
												>&nbsp;&nbsp;Reservation&nbsp;&nbsp;&nbsp;</span
											>
										</a>
									</li>

									<li class="active">&nbsp;&nbsp;Booking Forms&nbsp;&nbsp;</li>
								</ol>
							</div>
							<div
								class="page-title-right"
								style="font-family: HeaderCustomFont"
							></div>
						</div>
					</div>
				</div>

				<div class="row card-body mt-0 pt-0">
					<div class="row">
						<div class="col-xl-12">
							<div class="card card-body p-4 text-dark">
								<div class="row col-sm-12">
									<div class="col-sm-7 float-sm-left text-start"></div>
									<div
										class="col-sm-5 d-flex justify-content-end gap-1"
										style="font-family: HeaderCustomFont"
									>
										<button
											class="btn text-none bg-info float-sm-right text-white rounded-0"
											@click="openModal('preview')"
										>
											<i class="nav-icon fas fa-print"></i>&nbsp;&nbsp;Booking
											Form
										</button>
									</div>
								</div>
								<div class="row mb-1 d-flex p-2">
									<div class="col-md-12">
										<div class="mb-1">
											<label for="agent_id" class="form-label"
												>Select Registered Tour</label
											>
											<!-- :items="this.infiniteTours.data" -->
											<v-autocomplete
												density="compact"
												variant="outlined"
												rounded="0"
												return-object
												:items="formsComputed"
												placeholder="Select Registerd Tour"
												v-model="filterForms.tour"
												@update:modelValue="selectForm($event)"
												:item-title="tourSelect"
												item-value="id"
												clearable
											>
											</v-autocomplete>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="row d-none">
						<div class="col-xl-12">
							<div class="card card-body p-4 text-dark">
								<div class="row col-sm-12 mt-2">
									<div class="table-responsive p-3">
										<v-text-field
											v-model="searchForms"
											label="Search Forms"
											prepend-inner-icon="mdi-magnify"
											flat
											rounded="0"
											variant="outlined"
											density="compact"
											class=""
										></v-text-field>
										<v-data-table
											v-model:items-per-page="formsPerPage"
											:headers="formHeaders"
											:items="formsComputed"
											:search="searchForms"
											density="compact"
											item-value="name"
											class="table-sm table-striped rounded-0 table-responsive table-wrap"
										>
											<template v-slot:body="{ items }">
												<tr v-if="selectedForm" :class="'selected-row'">
													<td class="align-middle">
														<font-awesome-icon icon="fas fa-thumbtack" />
													</td>
													<td class="align-middle">
														{{ selectedForm.reference_number }}
													</td>
													<td>
														{{ selectedForm.client }}
													</td>
													<td>{{ selectedForm.agent_name }}</td>
													<td>{{ selectedForm.guide_language }}</td>
													<td>
														{{ selectedForm.from }}
													</td>
													<td>{{ selectedForm.to }}</td>
													<td></td>
												</tr>
												<tr>
													<td></td>
													<td></td>
													<td></td>
													<td></td>
													<td></td>
													<td></td>
													<td></td>
													<td></td>
												</tr>
												<!-- :class="{ 'selected-row': selectedForm && item.tour_id === selectedForm.tour_id, }" -->
												<tr
													@click.prevent=""
													@click="selectForm(item)"
													v-for="(item, index) in items"
													:key="item.tour_id"
												>
													<td>{{ item.index + 1 }}</td>
													<td>{{ item.reference_number }}</td>
													<td>{{ item.client }}</td>
													<td>{{ item.agent_name }}</td>
													<td>{{ item.guide_language }}</td>
													<td>{{ item.from }}</td>
													<td>{{ item.to }}</td>
													<td>{{ item.permit_status }}</td>
													<!-- Accommodation -->
													<td class="d-none">
														<v-icon large @click="deleteRecord(item)">
															mdi-access-point-remove
														</v-icon>

														<v-icon large @click="editRecord(item)">
															mdi-pencil
														</v-icon>

														<v-icon large @click="displayReport(item)">
															mdi-file-document
														</v-icon>
													</td>
												</tr>
											</template>
										</v-data-table>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- </div> -->
				</div>

				<div class="row card-body mt-0 p-4">
					<div class="row">
						<div class="col-xl-12">
							<!-- <div class="card"> -->
							<!-- <div class="row card-body"> -->
							<v-expansion-panels v-model="openPanels.tourGuests">
								<v-expansion-panel expand>
									<v-expansion-panel-title
										density="compact"
										class="compact-header text-dark rounded-0"
									>
										Tour Guests
									</v-expansion-panel-title>
									<v-expansion-panel-text>
										<div class="card card-body accordion-body text-dark">
											<div class="row col-sm-12">
												<div class="col-sm-7 float-sm-left text-start"></div>
												<div
													class="col-sm-5 text-end"
													style="font-family: HeaderCustomFont"
												>
													<!-- @click="openModal(modal, data)" -->
													<button
														:disabled="!currentRoute"
														class="btn text-none bg-green-custom float-sm-right text-white rounded-0"
														@click="openModal('guest')"
													>
														<i class="nav-icon fas fa-plus"></i>&nbsp;&nbsp;Tour
														Guest
													</button>
												</div>
											</div>
											<div class="row col-sm-12 mt-2">
												<div class="table-responsive p-1">
													<v-text-field
														v-model="searchGuests"
														label="Search Tour Guests"
														prepend-inner-icon="mdi-magnify"
														flat
														rounded="0"
														variant="outlined"
														density="compact"
														class="d-none"
													></v-text-field>
													<v-data-table
														v-model:items-per-page="guestsPerPage"
														:headers="guestsHeaders"
														:items="guestsComputed"
														:search="searchGuests"
														density="compact"
														item-value="name"
														class="table-sm table-striped rounded-0 table-responsive table-wrap"
													>
														<template v-slot:body="{ items }">
															<tr
																v-for="(item, index) in items"
																:key="item.name"
															>
																<td>{{ item.index + 1 }}</td>
																<td>{{ item.name }}</td>
																<td>{{ item.guest?.country?.name }}</td>
																<!-- <td>{{ item.DOB }}</td> -->
																<td>{{ item.guest?.passport_no }}</td>
																<!-- <td>{{ item.Passport }}</td> -->
																<td>{{ item.arrival_info }}</td>
																<td>{{ item.departure_info }}</td>
																<!-- <td>{{ item.total_cost }}</td> -->
																<td class="">
																	<v-menu v-if="currentRoute" offset-y>
																		<template v-slot:activator="{ props }">
																			<v-icon v-bind="props" size="24">
																				mdi-dots-horizontal
																			</v-icon>
																		</template>

																		<v-list
																			density="compact"
																			class="custom-dropdown"
																		>
																			<v-list-item
																				@click="manageGuests(item, 'edit')"
																			>
																				<v-list-item-title
																					><font-awesome-icon
																						icon="fa-regular fa-pen-to-square"
																					/>&nbsp;&nbsp;&nbsp;&nbsp;Edit</v-list-item-title
																				>
																			</v-list-item>
																			<v-list-item
																				@click="manageGuests(item, 'delete')"
																			>
																				<v-list-item-title
																					><font-awesome-icon
																						icon="fa-solid fa-trash"
																					/>&nbsp;&nbsp;&nbsp;&nbsp;Delete</v-list-item-title
																				>
																			</v-list-item>
																		</v-list>
																	</v-menu>
																</td>
															</tr>
														</template>
													</v-data-table>
												</div>
											</div>
										</div>
									</v-expansion-panel-text>
								</v-expansion-panel>
							</v-expansion-panels>
							<!-- </div> -->
							<!-- </div> -->
						</div>
					</div>
				</div>

				<div class="row card-body mt-0 p-4">
					<div class="row">
						<div class="col-xl-12">
							<!-- <div class="card"> -->
							<!-- <div class="row card-body"> -->
							<v-expansion-panels v-model="openPanels.tourAccomodation">
								<v-expansion-panel expand>
									<v-expansion-panel-title
										density="compact"
										class="compact-header text-dark rounded-0"
									>
										Tour Accomodation
									</v-expansion-panel-title>
									<v-expansion-panel-text>
										<div class="card card-body accordion-body text-dark">
											<div class="row col-sm-12">
												<div class="col-sm-7 float-sm-left text-start"></div>
												<div
													class="col-sm-5 text-end"
													style="font-family: HeaderCustomFont"
												>
													<!-- @click="openModal(modal, data)" -->
													<button
														:disabled="!currentRoute"
														class="btn text-none bg-green-custom float-sm-right text-white rounded-0 d-none"
														@click="openModal('accomodation')"
													>
														<i class="nav-icon fas fa-plus"></i>&nbsp;&nbsp;Tour
														Accomodation
													</button>
												</div>
											</div>
											<div class="row col-sm-12 mt-2">
												<div class="table-responsive p-1">
													<v-text-field
														v-model="searchAccomodation"
														label="Search Tour Accomodations"
														prepend-inner-icon="mdi-magnify"
														flat
														rounded="0"
														variant="outlined"
														density="compact"
														class="d-none"
													></v-text-field>
													<v-data-table
														v-model:items-per-page="accomodationPerPage"
														:headers="accomodationsHeaders"
														:items="accomodationComputed"
														:search="searchAccomodation"
														density="compact"
														item-value="name"
														class="table-sm table-striped rounded-0 table-responsive table-wrap"
													>
														<template v-slot:body="{ items }">
															<tr
																class="align-top"
																v-for="(item, index) in items"
																:key="item.id"
															>
																<td>{{ item.index + 1 }}</td>
																<td>{{ item.lodge?.name }}</td>
																<!-- <td>{{ item.rooms }}</td> -->
																<!-- <td>{{ item.meal }}</td> -->
																<td>{{ item.no_nights }}</td>
																<td>{{ item.room?.name }}</td>
																<td>{{ item.meal?.name }}</td>
																<td>
																	{{
																		item.check_in ? longDate(item.check_in) : ""
																	}}
																</td>
																<!-- <td>{{ item.booking_date }}</td> -->
																<!-- <td>{{ item.confirmation_date }}</td> -->
																<!-- <td>{{ item.comment }}</td> -->
																<td class="">
																	<v-menu v-if="currentRoute" offset-y>
																		<template v-slot:activator="{ props }">
																			<v-icon v-bind="props" size="24">
																				mdi-dots-horizontal
																			</v-icon>
																		</template>

																		<v-list
																			density="compact"
																			class="custom-dropdown"
																		>
																			<v-list-item
																				@click="
																					manageAccomodation(item, 'edit')
																				"
																			>
																				<v-list-item-title
																					><font-awesome-icon
																						icon="fa-regular fa-pen-to-square"
																					/>&nbsp;&nbsp;&nbsp;&nbsp;Edit</v-list-item-title
																				>
																			</v-list-item>
																			<v-list-item
																				class="d-none"
																				@click="
																					manageAccomodation(item, 'delete')
																				"
																			>
																				<v-list-item-title
																					><font-awesome-icon
																						icon="fa-solid fa-trash"
																					/>&nbsp;&nbsp;&nbsp;&nbsp;Delete</v-list-item-title
																				>
																			</v-list-item>
																		</v-list>
																	</v-menu>
																</td>
															</tr>
														</template>
													</v-data-table>
												</div>
											</div>
										</div>
									</v-expansion-panel-text>
								</v-expansion-panel>
							</v-expansion-panels>
							<!-- </div> -->
							<!-- </div> -->
						</div>
					</div>
				</div>

				<div class="row card-body mt-0 p-4">
					<div class="row">
						<div class="col-xl-12">
							<!-- <div class="card"> -->
							<!-- <div class="row card-body"> -->
							<v-expansion-panels v-model="openPanels.tourActivity">
								<v-expansion-panel expand>
									<v-expansion-panel-title
										density="compact"
										class="compact-header text-dark rounded-0"
									>
										Tour Activity
									</v-expansion-panel-title>
									<v-expansion-panel-text>
										<div class="card card-body accordion-body text-dark">
											<div class="row col-sm-12">
												<div class="col-sm-7 float-sm-left text-start"></div>
												<div
													class="col-sm-5 text-end"
													style="font-family: HeaderCustomFont"
												>
													<!-- @click="openModal(modal, data)" -->
													<button
														:disabled="!currentRoute"
														class="btn text-none bg-green-custom float-sm-right text-white rounded-0"
														@click="openModal('itinerary')"
													>
														<i class="nav-icon fas fa-plus"></i>&nbsp;&nbsp;Tour
														Activity
													</button>
												</div>
											</div>
											<div class="row col-sm-12 mt-2">
												<div class="table-responsive p-1">
													<v-text-field
														v-model="searchActivity"
														label="Search Tour Activity"
														prepend-inner-icon="mdi-magnify"
														flat
														rounded="0"
														variant="outlined"
														density="compact"
														class="d-none"
													></v-text-field>
													<v-data-table
														v-model:items-per-page="activityPerPage"
														:headers="activityHeaders"
														:items="activityComputed"
														:search="searchActivity"
														density="compact"
														item-value="name"
														class="table-sm table-striped rounded-0 table-responsive table-wrap"
													>
														<template v-slot:body="{ items }">
															<tr
																class="align-top"
																v-for="(item, index) in items"
																:key="item.id"
															>
																<td>{{ item.index + 1 }}</td>
																<td>{{ "Day " + item.day_number }}</td>
																<td>
																	{{ capitalizeWords(item.itinerary_title) }}
																</td>
																<td>{{ item.pax }}</td>
																<td v-if="item.park !== null">
																	{{ capitalizeWords(item.park.name) }}
																</td>
																<td v-else>
																	{{ capitalizeWords("No Park option") }}
																</td>
																<!-- <td>{{ item.date }}</td> -->
																<td v-if="item.lodge !== null">
																	{{ capitalizeWords(item.lodge.name) }}
																</td>
																<td v-else>
																	{{ capitalizeWords("No Lodge option") }}
																</td>
																<td class="">
																	<v-menu v-if="currentRoute" offset-y>
																		<template v-slot:activator="{ props }">
																			<v-icon v-bind="props" size="24">
																				mdi-dots-horizontal
																			</v-icon>
																		</template>

																		<v-list
																			density="compact"
																			class="custom-dropdown"
																		>
																			<v-list-item
																				@click="manageActivity(item, 'edit')"
																			>
																				<v-list-item-title
																					><font-awesome-icon
																						icon="fa-regular fa-pen-to-square"
																					/>&nbsp;&nbsp;&nbsp;&nbsp;Edit</v-list-item-title
																				>
																			</v-list-item>
																			<v-list-item
																				@click="manageActivity(item, 'delete')"
																			>
																				<v-list-item-title
																					><font-awesome-icon
																						icon="fa-solid fa-trash"
																					/>&nbsp;&nbsp;&nbsp;&nbsp;Delete</v-list-item-title
																				>
																			</v-list-item>
																			<v-list-item
																				class="d-none"
																				@click="selectItinerary(item)"
																			>
																				<v-list-item-title
																					><font-awesome-icon
																						icon="fa-regular fa-pen-to-square"
																					/>&nbsp;&nbsp;&nbsp;&nbsp;Activities</v-list-item-title
																				>
																			</v-list-item>
																		</v-list>
																	</v-menu>
																</td>
															</tr>
														</template>
													</v-data-table>
												</div>
											</div>
										</div>
									</v-expansion-panel-text>
								</v-expansion-panel>
							</v-expansion-panels>
							<!-- </div> -->
							<!-- </div> -->
						</div>
					</div>
				</div>

				<div class="row card-body mt-0 p-4">
					<div class="row">
						<div class="col-xl-12">
							<!-- <div class="card"> -->
							<!-- v-model="openPanels.tourFlights" -->
							<v-expansion-panels v-model="openPanels.tourFlights">
								<v-expansion-panel expand>
									<v-expansion-panel-title
										density="compact"
										class="compact-header text-dark rounded-0"
									>
										Flights
									</v-expansion-panel-title>
									<v-expansion-panel-text>
										<div class="card card-body accordion-body text-dark">
											<div class="row col-sm-12">
												<div class="col-sm-7 float-sm-left text-start"></div>
												<div
													class="col-sm-5 text-end"
													style="font-family: HeaderCustomFont"
												>
													<!--  -->
													<button
														:disabled="!currentRoute"
														class="d-none btn text-none bg-green-custom float-sm-right text-white rounded-0"
														@click="openModal('flights')"
													>
														<i class="nav-icon fas fa-plus"></i>&nbsp;&nbsp;Tour
														Flight
													</button>
												</div>
											</div>
											<div class="row col-sm-12 mt-2">
												<div class="table-responsive p-1">
													<v-text-field
														v-model="searchFlight"
														label="Search Tour Guests"
														prepend-inner-icon="mdi-magnify"
														flat
														rounded="0"
														variant="outlined"
														density="compact"
														class="d-none"
													></v-text-field>
													<v-data-table
														v-model:items-per-page="flightPerPage"
														:headers="flightHeaders"
														:items="flightsComputed"
														:search="searchFlight"
														density="compact"
														item-value="name"
														class="table-sm table-striped rounded-0 text-truncate table-nowrap"
													>
														<!-- <td> {{ item.flight.supplier ? item.flight.supplier.name : null }} </td> -->
														<template v-slot:body="{ items }">
															<tr
																v-for="(item, index) in items"
																:key="item.name"
															>
																<td>{{ index + 1 }}</td>
																<td>
																	{{ item.flight ? item.flight.name : null }}
																</td>

																<td>{{ item.pax }}</td>
																<td>
																	{{ item.date ? longDate(item.date) : "" }}
																</td>
																<!-- <td>{{ item.departure }}</td> -->
																<!-- <td>{{ item.arrival }}</td> -->
																<td>
																	{{
																		item.departure_time
																			? item.departure_time
																			: null + "/" + item.arrival_time
																			? item.arrival_time
																			: null
																	}}
																</td>
																<td>
																	{{
																		item.confirmation_date
																			? longDate(item.confirmation_date)
																			: ""
																	}}
																</td>
																<td class="">
																	<v-menu v-if="currentRoute" offset-y>
																		<template v-slot:activator="{ props }">
																			<v-icon v-bind="props" size="24">
																				mdi-dots-horizontal
																			</v-icon>
																		</template>

																		<v-list
																			density="compact"
																			class="custom-dropdown"
																		>
																			<v-list-item
																				@click="manageFlights(item, 'edit')"
																			>
																				<v-list-item-title
																					><font-awesome-icon
																						icon="fa-regular fa-pen-to-square"
																					/>&nbsp;&nbsp;&nbsp;&nbsp;Edit</v-list-item-title
																				>
																			</v-list-item>
																			<v-list-item
																				class="d-none"
																				@click="manageFlights(item, 'delete')"
																			>
																				<v-list-item-title
																					><font-awesome-icon
																						icon="fa-solid fa-trash"
																					/>&nbsp;&nbsp;&nbsp;&nbsp;Delete</v-list-item-title
																				>
																			</v-list-item>
																		</v-list>
																	</v-menu>
																</td>
															</tr>
														</template>
													</v-data-table>
												</div>
											</div>
										</div>
									</v-expansion-panel-text>
								</v-expansion-panel>
							</v-expansion-panels>
							<!-- </div> -->
							<!-- </div> -->
						</div>
					</div>
				</div>

				<div class="row card-body mt-0 p-4">
					<div class="row">
						<div class="col-xl-12">
							<!-- <div class="card"> -->
							<!-- v-model="openPanels.tourBoats" -->
							<v-expansion-panels v-model="openPanels.tourBoats">
								<v-expansion-panel expand>
									<v-expansion-panel-title
										density="compact"
										class="compact-header text-dark rounded-0"
									>
										Boats
									</v-expansion-panel-title>
									<v-expansion-panel-text>
										<div class="card card-body accordion-body text-dark">
											<div class="row col-sm-12">
												<div class="col-sm-7 float-sm-left text-start"></div>
												<div
													class="col-sm-5 text-end"
													style="font-family: HeaderCustomFont"
												>
													<!-- @click="openModal(modal, data)" -->
													<button
														:disabled="!currentRoute"
														class="d-none btn text-none bg-green-custom float-sm-right text-white rounded-0"
														@click="openModal('boats')"
													>
														<i class="nav-icon fas fa-plus"></i>&nbsp;&nbsp;Tour
														Boat
													</button>
												</div>
											</div>
											<div class="row col-sm-12 mt-2">
												<div class="table-responsive p-1">
													<v-text-field
														v-model="searchBoats"
														label="Search Tour Guests"
														prepend-inner-icon="mdi-magnify"
														flat
														rounded="0"
														variant="outlined"
														density="compact"
														class="d-none"
													></v-text-field>
													<v-data-table
														v-model:items-per-page="boatsPerPage"
														:headers="boatsHeaders"
														:items="boatsComputed"
														:search="searchBoats"
														density="compact"
														item-value="name"
														class="table-sm table-striped rounded-0 text-truncate table-nowrap"
													>
														<template v-slot:body="{ items }">
															<tr v-for="(item, index) in items" :key="item.id">
																<td>{{ index + 1 }}</td>
																<td>{{ item.boat ? item.boat.name : null }}</td>
																<td>{{ item.pax }}</td>
																<td>
																	{{ item.date ? longDate(item.date) : "" }}
																</td>
																<!-- <td>{{ item.departure }}</td> -->
																<!-- <td>{{ item.arrival }}</td> -->
																<td>
																	{{
																		item.booking_date
																			? longDate(item.booking_date)
																			: ""
																	}}
																</td>
																<td>
																	{{
																		item.confirmation_date
																			? longDate(item.confirmation_date)
																			: ""
																	}}
																</td>
																<td class="">
																	<v-menu v-if="currentRoute" offset-y>
																		<template v-slot:activator="{ props }">
																			<v-icon v-bind="props" size="24">
																				mdi-dots-horizontal
																			</v-icon>
																		</template>

																		<v-list
																			density="compact"
																			class="custom-dropdown"
																		>
																			<v-list-item
																				@click="manageBoats(item, 'edit')"
																			>
																				<v-list-item-title
																					><font-awesome-icon
																						icon="fa-regular fa-pen-to-square"
																					/>&nbsp;&nbsp;&nbsp;&nbsp;Edit</v-list-item-title
																				>
																			</v-list-item>
																			<v-list-item
																				class="d-none"
																				@click="manageBoats(item, 'delete')"
																			>
																				<v-list-item-title
																					><font-awesome-icon
																						icon="fa-solid fa-trash"
																					/>&nbsp;&nbsp;&nbsp;&nbsp;Delete</v-list-item-title
																				>
																			</v-list-item>
																		</v-list>
																	</v-menu>
																</td>
															</tr>
														</template>
													</v-data-table>
												</div>
											</div>
										</div>
									</v-expansion-panel-text>
								</v-expansion-panel>
							</v-expansion-panels>
							<!-- </div> -->
							<!-- </div> -->
						</div>
					</div>
				</div>
			</div>

			<v-dialog v-model="guestModal" max-width="1250px" persistent>
				<v-card>
					<form
						@submit.prevent="
							editMode
								? manageGuests(this.tourGuest, 'update')
								: manageGuests(this.tourGuest, 'insert')
						"
					>
						<v-card-title class="d-flex justify-space-between align-center">
							<div class="modal-header">
								<!-- <slot name="header">default header</slot> -->
								<h5
									class="modal-title font-size-20 text-dark"
									style="font-family: HeaderCustomFont"
								>
									<font-awesome-icon icon="fas fa-handshake" />&nbsp;&nbsp;Tour
									Guest
								</h5>
							</div>
							<v-icon @click="closeModal('guest')">mdi-close</v-icon>
						</v-card-title>
						<!-- Dialog Content -->
						<v-card-text>
							<div class="modal-body p-4">
								<div
									id="preloader d-none"
									class="col-sm-2 p-5"
									v-if="this.processing"
								>
									<div id="status">
										<div class="spinner-chase text-start">
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
										</div>
									</div>
								</div>
								<div class="text-start">
									<div class="row mt-1">
										<div class="col-md-6 required">
											<label for="guest_id" class="form-label"
												><span
													v-if="tourGuest.errors.has('guest_id')"
													class="text-danger text-lowercase"
												>
													{{ tourGuest.errors.get("guest_id") }} </span
												><span v-else>Select Tourist</span></label
											>&nbsp;&nbsp;<span class="text-info"
												><a
													href="#"
													@click.prevent=""
													@click="openModal('tourist')"
													><font-awesome-icon
														icon="fa-solid fa-folder-plus"
														size="xl" /></a
											></span>
											<v-autocomplete
												density="compact"
												variant="outlined"
												rounded="0"
												return-object
												placeholder="Select Guest"
												:items="this.infiniteTourists.data"
												v-model="tourGuest.guest_id"
												@update:modelValue="selectGuest($event)"
												item-value="id"
												item-title="name"
												id="guest_id"
											>
											</v-autocomplete>
										</div>
										<div class="col-md-6 required">
											<div class="">
												<label for="name" class="form-label"
													><span
														v-if="tourGuest.errors.has('name')"
														class="text-danger text-lowercase"
													>
														{{ tourGuest.errors.get("name") }} </span
													><span v-else>Guest Name</span></label
												>
												<v-text-field
													density="compact"
													variant="outlined"
													rounded="0"
													clearable
													placeholder="Guest Name"
													v-model="tourGuest.name"
													id="name"
													:disabled="!tourGuest.guest_id"
												></v-text-field>
											</div>
										</div>
									</div>
									<div class="row mt-1">
										<div class="col-md-6 required">
											<div class="mb-3">
												<label for="arrival_info" class="form-label"
													><span
														v-if="tourGuest.errors.has('arrival_info')"
														class="text-danger text-lowercase"
													>
														{{ tourGuest.errors.get("arrival_info") }} </span
													><span v-else>Arrival Information</span></label
												>
												<v-textarea
													density="compact"
													variant="outlined"
													rounded="0"
													rows="5"
													placeholder="Arrival Information"
													v-model="tourGuest.arrival_info"
													id="arrival_info"
												></v-textarea>
											</div>
										</div>
										<div class="col-md-6 required">
											<div class="mb-3">
												<label for="departure_info" class="form-label"
													><span
														v-if="tourGuest.errors.has('departure_info')"
														class="text-danger text-lowercase"
													>
														{{ tourGuest.errors.get("departure_info") }} </span
													><span v-else>Departure Information</span></label
												>
												<v-textarea
													density="compact"
													variant="outlined"
													rounded="0"
													rows="5"
													placeholder="Departure Information"
													v-model="tourGuest.departure_info"
													id="departure_info"
												></v-textarea>
											</div>
										</div>
									</div>
								</div>
							</div>
						</v-card-text>

						<!-- Footer with Action Buttons -->
						<v-card-actions>
							<v-spacer>
								<!-- end of modal body -->
								<div
									class="justify-content-start modal-footer"
									style="font-family: HeaderCustomFont"
								>
									<button
										:disabled="!currentRoute"
										type="submit"
										class="btn bg-green-custom text-white w-10 m-2"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Save Tour
									</button>
									<button
										type="button"
										class="btn bg-danger text-white w-10 m-2"
										@click="closeModal('guest')"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Close
									</button>
								</div>
							</v-spacer>
							<!-- <v-btn color="primary" @click="tourModal = false">Close</v-btn> -->
						</v-card-actions>
					</form>
				</v-card>
			</v-dialog>

			<v-dialog v-model="touristModal" max-width="1250px" persistent>
				<v-card>
					<form
						@submit.prevent="
							editMode
								? manageTourists(this.touristRegister, 'update')
								: manageTourists(this.touristRegister, 'insert')
						"
					>
						<v-card-title class="d-flex justify-space-between align-center">
							<div class="modal-header">
								<!-- <slot name="header">default header</slot> -->
								<h5
									class="modal-title font-size-20 text-dark"
									style="font-family: HeaderCustomFont"
								>
									<font-awesome-icon
										icon="fas fa-handshake"
									/>&nbsp;&nbsp;Manage Tourists
								</h5>
							</div>
							<v-icon @click="closeModal('tourist')">mdi-close</v-icon>
						</v-card-title>
						<!-- Dialog Content -->
						<v-card-text>
							<div class="modal-body p-4">
								<div
									id="preloader d-none"
									class="col-sm-2 p-5"
									v-if="this.processing"
								>
									<div id="status">
										<div class="spinner-chase text-start">
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
										</div>
									</div>
								</div>
								<div class="text-start">
									<div class="row mt-1">
										<div class="col-md-4 required">
											<label for="name" class="form-label"
												><span
													v-if="touristRegister.errors.has('name')"
													class="text-danger text-lowercase"
												>
													{{ touristRegister.errors.get("name") }} </span
												><span v-else>Guest Name</span></label
											>
											<v-text-field
												density="compact"
												variant="outlined"
												rounded="0"
												clearable
												placeholder="Tourist Name"
												v-model="touristRegister.name"
												item-value="id"
												item-title="name"
												id="accommodation_id"
											>
											</v-text-field>
										</div>
										<div class="col-md-2">
											<div class="mb-3">
												<label for="dob" class="form-label"
													><span
														v-if="touristRegister.errors.has('dob')"
														class="text-danger text-lowercase"
													>
														{{ touristRegister.errors.get("dob") }} </span
													><span v-else>Date of Birth</span></label
												>
												<v-text-field
													density="compact"
													variant="outlined"
													rounded="0"
													type="date"
													clearable
													placeholder="Start Date"
													v-model="touristRegister.dob"
													id="dob"
													><template v-slot:prefix>
														<v-icon icon="mdi-calendar"></v-icon></template
												></v-text-field>
											</div>
										</div>
										<div class="col-md-4 required">
											<div class="mb-3">
												<label for="gender" class="form-label"
													><span
														v-if="touristRegister.errors.has('gender')"
														class="text-danger text-lowercase"
													>
														{{ touristRegister.errors.get("gender") }} </span
													><span v-else>Gender</span></label
												>
												<v-combobox
													:items="this.infiniteGenders"
													density="compact"
													variant="outlined"
													rounded="0"
													clearable
													placeholder="Select Gender"
													v-model="touristRegister.gender"
													id="gender"
												></v-combobox>
											</div>
										</div>
									</div>
									<div class="row mt-1">
										<div class="col-md-4">
											<div class="mb-3">
												<label for="passport_no" class="form-label"
													>Passport</label
												>
												<v-text-field
													density="compact"
													variant="outlined"
													rounded="0"
													clearable
													placeholder="Passport Number"
													v-model="touristRegister.passport_no"
													id="passport_no"
												></v-text-field>
											</div>
										</div>
										<div class="col-md-4 required">
											<div class="mb-0">
												<label for="country_id" class="form-label"
													><span
														v-if="touristRegister.errors.has('country_id')"
														class="text-danger text-lowercase"
													>
														{{
															touristRegister.errors.get("country_id")
														}} </span
													><span v-else>Nationality</span></label
												>
												<v-autocomplete
													density="compact"
													variant="outlined"
													rounded="0"
													return-object
													placeholder="Select Country"
													:items="this.infiniteCountries.data"
													v-model="touristRegister.country_id"
													item-title="name"
													item-value="id"
													id="country_id"
												>
												</v-autocomplete>
											</div>
										</div>
									</div>
								</div>
							</div>
						</v-card-text>

						<!-- Footer with Action Buttons -->
						<v-card-actions>
							<v-spacer>
								<!-- end of modal body -->
								<div
									class="justify-content-start modal-footer"
									style="font-family: HeaderCustomFont"
								>
									<button
										:disabled="!currentRoute"
										type="submit"
										class="btn bg-green-custom text-white w-10 m-2"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Save Tourist
									</button>
									<button
										type="button"
										class="btn bg-danger text-white w-10 m-2"
										@click="closeModal('tourist')"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Close
									</button>
								</div>
							</v-spacer>
							<!-- <v-btn color="primary" @click="tourModal = false">Close</v-btn> -->
						</v-card-actions>
					</form>
				</v-card>
			</v-dialog>

			<v-dialog v-model="accomodationModal" max-width="1250px" persistent>
				<v-card
					><form
						@submit.prevent="
							editMode
								? manageAccomodation(this.tourAccomodation, 'update')
								: manageAccomodation(this.tourAccomodation, 'insert')
						"
					>
						<v-card-title class="d-flex justify-space-between align-center">
							<div class="modal-header">
								<!-- <slot name="header">default header</slot> -->
								<h5
									class="modal-title font-size-20 text-dark"
									style="font-family: HeaderCustomFont"
								>
									<font-awesome-icon icon="fas fa-handshake" />&nbsp;&nbsp;Tour
									Accomodations
								</h5>
							</div>
							<v-icon @click="closeModal('accomodation')">mdi-close</v-icon>
						</v-card-title>
						<!-- Dialog Content -->
						<v-card-text>
							<div class="modal-body p-4">
								<div
									id="preloader d-none"
									class="col-sm-2 p-5"
									v-if="this.processing"
								>
									<div id="status">
										<div class="spinner-chase text-start">
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
										</div>
									</div>
								</div>
								<div class="text-start">
									<div class="row mt-1">
										<div class="col-md-6">
											<div class="mb-3">
												<label for="lodge_id" class="form-label"
													>Accomodation</label
												>
												<span
													v-if="tourAccomodation.errors.has('lodge_id')"
													class="text-danger text-lowercase"
												>
													{{ tourAccomodation.errors.get("lodge_id") }}
												</span>
												<v-autocomplete
													density="compact"
													variant="outlined"
													rounded="0"
													return-object
													placeholder="Select Agent"
													:items="this.infiniteAccomodations.data"
													v-model="tourAccomodation.lodge_id"
													item-title="name"
													item-value="id"
													id="lodge_id"
												>
												</v-autocomplete>
											</div>
										</div>
										<div class="col-md-3">
											<div class="mb-3">
												<label for="meal_plan_id" class="form-label"
													>Meal Plan</label
												>
												<span
													v-if="tourAccomodation.errors.has('meal_plan_id')"
													class="text-danger text-lowercase"
												>
													{{ tourAccomodation.errors.get("meal_plan_id") }}
												</span>
												<v-autocomplete
													density="compact"
													variant="outlined"
													rounded="0"
													placeholder="Select Meal"
													:items="this.infiniteMeals.data"
													v-model="tourAccomodation.meal_plan_id"
													item-title="name"
													item-value="id"
													id="meal_plan_id"
												>
												</v-autocomplete>
											</div>
										</div>
										<div class="col-md-3">
											<div class="mb-3">
												<label for="room_type" class="form-label">Room</label>
												<span
													v-if="tourAccomodation.errors.has('room_type')"
													class="text-danger text-lowercase"
												>
													{{ tourAccomodation.errors.get("room_type") }}
												</span>
												<v-autocomplete
													density="compact"
													variant="outlined"
													rounded="0"
													return-object
													placeholder="Select Room Type"
													:items="this.infiniteRooms.data"
													v-model="tourAccomodation.room_type"
													item-title="name"
													item-value="id"
													id="room_type"
												>
												</v-autocomplete>
											</div>
										</div>
									</div>
									<div class="row mt-1">
										<div class="col-md-2">
											<div class="mb-3">
												<label for="room_no" class="form-label">Room No</label>
												<span
													v-if="tourAccomodation.errors.has('room_no')"
													class="text-danger text-lowercase"
												>
													{{ tourAccomodation.errors.get("room_no") }}
												</span>
												<v-text-field
													density="compact"
													variant="outlined"
													rounded="0"
													clearable
													placeholder="Number of Rooms"
													v-model="tourAccomodation.room_no"
													id="room_no"
												></v-text-field>
											</div>
										</div>
										<div class="col-md-2">
											<div class="mb-3">
												<label for="no_nights" class="form-label"
													>Days/Nights</label
												>
												<span
													v-if="tourAccomodation.errors.has('no_nights')"
													class="text-danger text-lowercase"
												>
													{{ tourAccomodation.errors.get("no_nights") }}
												</span>
												<v-text-field
													density="compact"
													variant="outlined"
													rounded="0"
													clearable
													placeholder="Number of Nights"
													v-model="tourAccomodation.no_nights"
													id="no_nights"
												></v-text-field>
											</div>
										</div>
										<div class="col-md-2">
											<div class="">
												<label for="check_in" class="form-label"
													><span
														v-if="tourAccomodation.errors.has('check_in')"
														class="text-danger text-lowercase"
													>
														{{ tourAccomodation.errors.get("check_in") }} </span
													><span v-else>Check In</span></label
												>

												<v-autocomplete
													density="compact"
													variant="outlined"
													rounded="0"
													return-object
													placeholder="Day Number"
													:items="this.tourDays.data"
													v-model="tourAccomodation.check_in"
													item-title="Title"
													item-value="Day"
												>
												</v-autocomplete>
											</div>
										</div>
										<div class="col-md-2">
											<div class="">
												<label for="check_out" class="form-label"
													><span
														v-if="tourAccomodation.errors.has('check_out')"
														class="text-danger text-lowercase"
													>
														{{
															tourAccomodation.errors.get("check_out")
														}} </span
													><span v-else>Check Out</span></label
												>

												<v-autocomplete
													density="compact"
													variant="outlined"
													rounded="0"
													return-object
													placeholder="Day Number"
													:items="this.tourDays.data"
													v-model="tourAccomodation.check_out"
													item-title="Title"
													item-value="Day"
												>
												</v-autocomplete>
											</div>
										</div>
										<div class="col-md-2 d-none">
											<div class="mb-3">
												<label for="booking_date" class="form-label"
													>Booking Date</label
												>
												<span
													v-if="tourAccomodation.errors.has('booking_date')"
													class="text-danger text-lowercase"
												>
													{{ tourAccomodation.errors.get("booking_date") }}
												</span>
												<v-text-field
													density="compact"
													variant="outlined"
													rounded="0"
													type="date"
													clearable
													placeholder="Booking Date"
													v-model="tourAccomodation.booking_date"
													id="booking_date"
												></v-text-field>
											</div>
										</div>
										<div class="col-md-2">
											<div class="mb-3">
												<label for="confirmation" class="form-label"
													>Confirmation Date</label
												>
												<span
													v-if="tourAccomodation.errors.has('confirmation')"
													class="text-danger text-lowercase"
												>
													{{ tourAccomodation.errors.get("confirmation") }}
												</span>
												<v-text-field
													density="compact"
													variant="outlined"
													rounded="0"
													type="date"
													clearable
													placeholder="Confirmation Date"
													v-model="tourAccomodation.confirmation"
													id="confirmation"
												></v-text-field>
											</div>
										</div>
									</div>
									<div class="row mt-1">
										<div class="col-md-12">
											<div class="mb-3">
												<label for="comments" class="form-label"
													>Comments</label
												>
												<span
													v-if="tourAccomodation.errors.has('comments')"
													class="text-danger text-lowercase"
												>
													{{ tourAccomodation.errors.get("comments") }}
												</span>
												<v-textarea
													density="compact"
													variant="outlined"
													rounded="0"
													rows="5"
													placeholder="Comments"
													v-model="tourAccomodation.comments"
													id="comments"
												></v-textarea>
											</div>
										</div>
									</div>
								</div>
							</div>
							<!-- end of modal body -->
						</v-card-text>

						<!-- Footer with Action Buttons -->
						<v-card-actions>
							<v-spacer>
								<!-- end of modal body -->
								<div
									class="justify-content-start modal-footer"
									style="font-family: HeaderCustomFont"
								>
									<button
										:disabled="!currentRoute"
										type="submit"
										class="btn bg-green-custom text-white w-10 m-2"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Save
										Accomodation
									</button>
									<button
										type="button"
										class="btn bg-danger text-white w-10 m-2"
										@click="closeModal('accomodation')"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Close
									</button>
								</div>
							</v-spacer>
						</v-card-actions>
					</form>
				</v-card>
			</v-dialog>

			<v-dialog v-model="activityModal" max-width="1250px" persistent>
				<v-card
					><form
						@submit.prevent="
							editMode
								? manageActivity(this.tourActivity, 'update')
								: manageActivity(this.tourActivity, 'insert')
						"
					>
						<v-card-title class="d-flex justify-space-between align-center">
							<div class="modal-header">
								<!-- <slot name="header">default header</slot> -->
								<h5
									class="modal-title font-size-20 text-dark"
									style="font-family: HeaderCustomFont"
								>
									<font-awesome-icon icon="fas fa-handshake" />&nbsp;&nbsp;Tour
									Activities
								</h5>
							</div>
							<v-icon @click="closeModal('tour')">mdi-close</v-icon>
						</v-card-title>
						<!-- Dialog Content -->
						<v-card-text style="max-height: 600px; overflow-y: auto">
							<!-- <Scroll-Div width="1200px" height="500px"> -->
							<div class="modal-body">
								<div class="card-body p-4">
									<div
										id="preloader d-none"
										class="col-sm-2 p-5"
										v-if="this.processing"
									>
										<div id="status">
											<div class="spinner-chase text-start">
												<div class="chase-dot"></div>
												<div class="chase-dot"></div>
												<div class="chase-dot"></div>
												<div class="chase-dot"></div>
												<div class="chase-dot"></div>
												<div class="chase-dot"></div>
											</div>
										</div>
									</div>
									<div class="text-start">
										<div class="row mt-3">
											<v-expansion-panels
												v-model="openPanels.itineraryActivity"
											>
												<v-expansion-panel expand>
													<v-expansion-panel-text>
														<div class="row mt-2">
															<div class="col-md-8 required">
																<div class="">
																	<label for="title" class="form-label"
																		><span
																			v-if="
																				tourActivity.errors.has(
																					'activity_title'
																				)
																			"
																			class="text-danger text-lowercase"
																		>
																			{{
																				tourActivity.errors.get(
																					"activity_title"
																				)
																			}} </span
																		><span v-else>Activity Title</span></label
																	>
																	<v-text-field
																		density="compact"
																		variant="outlined"
																		rounded="0"
																		clearable
																		placeholder="Tour Title"
																		v-model="tourActivity.activity_title"
																		id="title"
																	></v-text-field>
																</div>
															</div>

															<div class="col-md-4">
																<div class="mb-3">
																	<label for="pax" class="form-label"
																		>Pax No</label
																	><span
																		v-if="tourActivity.errors.has('pax')"
																		class="text-danger text-lowercase"
																	>
																		{{ tourActivity.errors.get("pax") }}
																	</span>
																	<v-text-field
																		density="compact"
																		variant="outlined"
																		rounded="0"
																		clearable
																		placeholder="Guest Number"
																		v-model="tourActivity.pax"
																		id="pax"
																	></v-text-field>
																</div>
															</div>
														</div>

														<div class="row mt-1 d-none">
															<div class="col-md-12">
																<div class="mb-4">
																	<label
																		for="additional_information"
																		class="form-label"
																		>Additional Information</label
																	><span
																		v-if="
																			tourActivity.errors.has(
																				'additional_information'
																			)
																		"
																		class="text-danger text-lowercase"
																	>
																		{{
																			tourActivity.errors.get(
																				"additional_information"
																			)
																		}}
																	</span>
																	<v-textarea
																		density="compact"
																		variant="outlined"
																		rounded="0"
																		rows="5"
																		placeholder="Comments"
																		v-model="
																			tourActivity.additional_information
																		"
																		id="additional_information"
																	></v-textarea>
																</div>
															</div>
														</div>
													</v-expansion-panel-text>
												</v-expansion-panel>
											</v-expansion-panels>
										</div>
										<div class="row mt-3">
											<v-expansion-panels
												v-model="openPanels.itineraryActivity"
											>
												<v-expansion-panel expand>
													<v-expansion-panel-text>
														<div class="row mt-2">
															<div class="modal-body p-4">
																<div class="mb-4">
																	<v-text-field
																		v-model="searchActivity"
																		label="Search Activity"
																		prepend-inner-icon="mdi-magnify"
																		flat
																		rounded="0"
																		variant="outlined"
																		density="compact"
																		class="d-none"
																	></v-text-field>
																	<v-data-table
																		v-model:items-per-page="activityPerPage"
																		:headers="activityHeaders"
																		:items="activityComputed"
																		:search="searchActivity"
																		density="compact"
																		item-value="name"
																		class="table-sm table-striped rounded-0 text-truncate table-nowrap"
																	>
																		<template v-slot:body="{ items }">
																			<!-- <a href="#" @click.prevent="" @click="selectTour(item)" > -->

																			<tr
																				href="#"
																				@click.prevent=""
																				@click="manageActivity(item, 'edit')"
																				class="align-top clickable-row"
																				v-for="(item, index) in items"
																				:key="item.id"
																			>
																				<td>
																					{{ item.index + 1 }}
																				</td>
																				<td>
																					{{ item.tour.reference_number }}
																				</td>
																				<td>
																					{{ item.activity_title }}
																				</td>
																				<td>
																					{{ selectedItinerary.date }}
																				</td>
																				<td>
																					{{ selectedItinerary.day_number }}
																				</td>
																				<!-- <td>{{ item.country }}</td> -->
																				<td>{{ item.pax }}</td>
																				<td>
																					{{
																						selectedItinerary.additional_information
																					}}
																				</td>
																				<td class="">
																					<v-menu v-if="currentRoute" offset-y>
																						<template
																							v-slot:activator="{ props }"
																						>
																							<v-icon v-bind="props" size="24">
																								mdi-dots-horizontal
																							</v-icon>
																						</template>

																						<v-list
																							density="compact"
																							class="custom-dropdown"
																						>
																							<v-list-item
																								@click="
																									manageActivity(item, 'delete')
																								"
																							>
																								<v-list-item-title
																									><font-awesome-icon
																										icon="fa-solid fa-trash"
																									/>&nbsp;&nbsp;&nbsp;&nbsp;Delete</v-list-item-title
																								>
																							</v-list-item>
																						</v-list>
																					</v-menu>
																				</td>
																			</tr>
																		</template>
																	</v-data-table>
																</div>
															</div>
														</div>
													</v-expansion-panel-text>
												</v-expansion-panel>
											</v-expansion-panels>
										</div>
									</div>
								</div>
							</div>
							<!-- end of modal body -->
							<!-- </Scroll-Div> -->
						</v-card-text>

						<!-- Footer with Action Buttons -->
						<v-card-actions>
							<v-spacer>
								<!-- end of modal body -->
								<div
									class="justify-content-start modal-footer"
									style="font-family: HeaderCustomFont"
								>
									<button
										:disabled="!currentRoute"
										type="submit"
										class="btn bg-green-custom text-white w-10 m-2"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Save Activity
									</button>
									<button
										type="button"
										class="btn bg-danger text-white w-10 m-2"
										@click="closeModal('activity')"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Close</button
									><button
										type="button"
										class="btn bg-primary text-white w-10 m-2"
										@click="manageActivity('None', 'reset')"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Reset
									</button>
								</div>
							</v-spacer>
							<!-- <v-btn color="primary" @click="tourModal = false">Close</v-btn> -->
						</v-card-actions>
					</form>
				</v-card>
			</v-dialog>

			<v-dialog v-model="itineraryModal" max-width="1250px" persistent>
				<v-card
					><form
						@submit.prevent="
							editMode
								? manageActivity(this.tourItinerary, 'update')
								: manageActivity(this.tourItinerary, 'insert')
						"
					>
						<!-- style=" position: sticky; top: 0; z-index: 10; background-color: white; " -->
						<v-card-title
							class="dialog-title d-flex justify-space-between align-center"
							><div class="modal-header">
								<!-- <slot name="header">default header</slot> -->
								<h5
									class="modal-title font-size-20 text-dark"
									style="font-family: HeaderCustomFont"
								>
									<font-awesome-icon icon="fas fa-handshake" />&nbsp;&nbsp;Tour
									Itinerary
								</h5>
							</div>
							<v-icon @click="closeModal('itinerary')">mdi-close</v-icon>
						</v-card-title>
						<!-- Dialog Content -->
						<!-- style="padding-bottom: 0px; overflow-y: auto; height: 600px" -->
						<v-card-text class="dialog-text">
							<div class="modal-body p-4">
								<div class="modal-body p-4">
									<div
										id="preloader d-none"
										class="col-sm-2 p-5"
										v-if="this.processing"
									>
										<div id="status">
											<div class="spinner-chase text-start">
												<div class="chase-dot"></div>
												<div class="chase-dot"></div>
												<div class="chase-dot"></div>
												<div class="chase-dot"></div>
												<div class="chase-dot"></div>
												<div class="chase-dot"></div>
											</div>
										</div>
									</div>
									<div class="text-start">
										<div class="row">
											<div class="col-md-12">
												<div class="mb-3 required">
													<label for="agent_id" class="form-label"
														><span
															v-if="tourItinerary.errors.has('itinerary_item')"
															class="text-danger text-lowercase"
														>
															{{
																tourItinerary.errors.get("itinerary_item")
															}} </span
														><span v-else>Itinerary Item</span></label
													>

													<v-autocomplete
														density="compact"
														variant="outlined"
														rounded="0"
														return-object
														placeholder="Select Itinerary Item"
														:items="this.infiniteItems.data"
														v-model="tourItinerary.itinerary_item"
														@update:modelValue="selectItem($event)"
														:item-title="(item) => capitalizeWords(item.title)"
														item-value="id"
													>
													</v-autocomplete>
												</div>
											</div>
										</div>
										<div class="row">
											<div class="col-md-7 required">
												<div class="">
													<label for="title" class="form-label"
														><span
															v-if="tourItinerary.errors.has('itinerary_title')"
															class="text-danger text-lowercase"
														>
															{{
																tourItinerary.errors.get("itinerary_title")
															}} </span
														><span v-else>Itinerary Title</span></label
													>
													<v-text-field
														density="compact"
														variant="outlined"
														rounded="0"
														clearable
														placeholder="Tour Title"
														v-model="tourItinerary.itinerary_title"
														id="title"
													></v-text-field>
												</div>
											</div>
											<div class="col-md-2 required">
												<div class="">
													<label for="day_number" class="form-label"
														><span
															v-if="tourItinerary.errors.has('day_number')"
															class="text-danger text-lowercase"
														>
															{{
																tourItinerary.errors.get("day_number")
															}} </span
														><span v-else>Day Number</span></label
													>

													<v-autocomplete
														density="compact"
														variant="outlined"
														rounded="0"
														return-object
														placeholder="Day Number"
														:items="this.tourDays.data"
														v-model="tourItinerary.day_number"
														item-title="Title"
														item-value="Day"
													>
													</v-autocomplete>
												</div>
											</div>
											<div class="col-md-3">
												<div class="mb-3">
													<label for="district_id" class="form-label"
														><span
															v-if="tourItinerary.errors.has('district_id')"
															class="text-danger text-lowercase"
														>
															{{
																tourItinerary.errors.get("district_id")
															}} </span
														><span v-else>Destination</span></label
													>
													<v-autocomplete
														density="compact"
														variant="outlined"
														rounded="0"
														return-object
														placeholder="Select District"
														:items="this.infiniteDistricts.data"
														v-model="tourItinerary.district_id"
														:item-title="
															(item) => capitalizeWords(item.district_name)
														"
														item-value="id"
														id="district_id"
													>
													</v-autocomplete>
												</div>
											</div>
										</div>
										<div class="row">
											<div
												class="col-md-4 required"
												v-if="this.selectedForm == null"
											>
												<div class="">
													<label for="tour_id" class="form-label"
														><span
															v-if="tourItinerary.errors.has('tour_id')"
															class="text-danger text-lowercase"
														>
															{{ tourItinerary.errors.get("tour_id") }} </span
														><span v-else>Select Tour</span></label
													>
													<v-autocomplete
														density="compact"
														variant="outlined"
														rounded="0"
														placeholder="Select Itinerary Tour"
														:items="this.bookingForms.data"
														v-model="tourItinerary.tour_id"
														item-value="id"
														item-title="reference_number"
														id="tour_id"
													>
													</v-autocomplete>
												</div>
											</div>
											<div class="col-md-2 d-none">
												<div class="">
													<label for="activity_date" class="form-label"
														><span
															v-if="tourItinerary.errors.has('activity_date')"
															class="text-danger text-lowercase"
														>
															{{
																tourItinerary.errors.get("activity_date")
															}} </span
														><span v-else>Date</span></label
													>
													<v-text-field
														density="compact"
														variant="outlined"
														rounded="0"
														type="date"
														clearable
														placeholder="Activity Date"
														v-model="tourItinerary.activity_date"
														id="activity_date"
													></v-text-field>
												</div>
											</div>
											<div class="col-md-6">
												<div class="">
													<label for="date" class="form-label"
														><span
															v-if="tourItinerary.errors.has('transit_time')"
															class="text-danger text-lowercase"
														>
															{{
																tourItinerary.errors.get("transit_time")
															}} </span
														><span v-else>Transit Time</span></label
													>
													<div class="d-flex gap-1">
														<v-text-field
															density="compact"
															variant="outlined"
															rounded="0"
															clearable
															placeholder="Time"
															v-model="tourItinerary.transit_time"
															id="transit_time"
															style="flex: 1"
														></v-text-field>
														<v-select
															density="compact"
															variant="outlined"
															rounded="0"
															clearable
															placeholder="Unit"
															:items="['Mins', 'Hours', 'Days', 'Weeks']"
															v-model="tourItinerary.transit_unit"
															id="transit_unit"
															style="flex: 1"
														></v-select>
														<v-select
															density="compact"
															variant="outlined"
															rounded="0"
															clearable
															placeholder="How"
															:items="[
																'Driving',
																'Walking',
																'Hiking',
																'Riding',
																'Sailing',
															]"
															v-model="tourItinerary.transit_method"
															id="transit_method"
															style="flex: 1"
														></v-select>
													</div>
												</div>
											</div>
											<div class="col-md-4">
												<div class="">
													<label for="date" class="form-label"
														><span
															v-if="tourItinerary.errors.has('distance')"
															class="text-danger text-lowercase"
														>
															{{ tourItinerary.errors.get("distance") }} </span
														><span v-else>Distance</span></label
													>
													<div class="d-flex gap-1">
														<v-text-field
															density="compact"
															variant="outlined"
															rounded="0"
															clearable
															placeholder="Distance"
															v-model="tourItinerary.distance"
															id="distance"
															style="flex: 1"
														></v-text-field>
														<v-select
															density="compact"
															variant="outlined"
															rounded="0"
															clearable
															placeholder="Units"
															:items="[
																'Km',
																'Metres',
																'Miles',
																'Yards',
																'Feet',
															]"
															v-model="tourItinerary.distance_unit"
															id="distance_unit"
															style="flex: 1"
														></v-select>
													</div>
												</div>
											</div>
											<div class="col-md-2">
												<div class="">
													<label for="date" class="form-label"
														><span
															v-if="tourItinerary.errors.has('flight_time')"
															class="text-danger text-lowercase"
														>
															{{
																tourItinerary.errors.get("flight_time")
															}} </span
														><span v-else>Flight Time</span></label
													>
													<v-text-field
														density="compact"
														variant="outlined"
														rounded="0"
														clearable
														placeholder="Flight Time"
														v-model="tourItinerary.flight_time"
														id="flight_time"
													></v-text-field>
												</div>
											</div>

											<div class="col-md-3 d-none">
												<div class="mb-3">
													<label for="town_id" class="form-label"
														><span
															v-if="tourItinerary.errors.has('town_id')"
															class="text-danger text-lowercase"
														>
															{{ tourItinerary.errors.get("town_id") }} </span
														><span v-else>Destination Town </span></label
													>
													<v-autocomplete
														density="compact"
														variant="outlined"
														rounded="0"
														return-object
														placeholder="Select Town"
														:items="filteredTowns"
														v-model="tourItinerary.town_id"
														:item-title="
															(item) => capitalizeWords(item.town_name)
														"
														item-value="id"
														id="town_id"
													>
													</v-autocomplete>
												</div>
											</div>
										</div>

										<div class="row">
											<div class="col-md-4">
												<div class="mb-3">
													<label for="park_id" class="form-label"
														><span
															v-if="tourItinerary.errors.has('park_id')"
															class="text-danger text-lowercase"
														>
															{{ tourItinerary.errors.get("park_id") }} </span
														><span v-else>National Park</span></label
													>
													<v-autocomplete
														density="compact"
														variant="outlined"
														rounded="0"
														return-object
														placeholder="Select National Park"
														:items="this.infiniteParks.data"
														v-model="tourItinerary.park_id"
														item-title="name"
														item-value="id"
														id="park_id"
													>
													</v-autocomplete>
												</div>
											</div>
											<div class="col-md-4">
												<div class="mb-3">
													<label for="accommodation_id" class="form-label"
														><span
															v-if="
																tourItinerary.errors.has('accommodation_id')
															"
															class="text-danger text-lowercase"
														>
															{{
																tourItinerary.errors.get("accommodation_id")
															}} </span
														><span v-else>Accomodation Option</span></label
													>
													<v-autocomplete
														density="compact"
														variant="outlined"
														rounded="0"
														return-object
														placeholder="Select Accomodation"
														:items="this.infiniteAccomodations.data"
														v-model="tourItinerary.accommodation_id"
														item-title="name"
														item-value="id"
														id="accommodation_id"
													>
													</v-autocomplete>
												</div>
											</div>
											<div
												class="col-md-2 required"
												v-if="tourItinerary.accommodation_id"
											>
												<div class="">
													<label for="meal_plan_id" class="form-label"
														><span
															v-if="tourItinerary.errors.has('meal_plan_id')"
															class="text-danger text-lowercase"
														>
															{{
																tourItinerary.errors.get("meal_plan_id")
															}} </span
														><span v-else>Meal Plan</span></label
													>
													<v-autocomplete
														density="compact"
														variant="outlined"
														rounded="0"
														clearable
														return-object
														placeholder="Select Plan"
														:items="this.infiniteMeals.data"
														v-model="tourItinerary.meal_plan_id"
														item-title="name"
														item-value="id"
														id="meal_plan_id"
													>
													</v-autocomplete>
												</div>
											</div>
											<div
												class="col-md-2"
												v-if="tourItinerary.accommodation_id"
											>
												<div class="mb-3">
													<label for="room_type" class="form-label"
														>Room Type</label
													>
													<span
														v-if="tourItinerary.errors.has('room_type')"
														class="text-danger text-lowercase"
													>
														{{ tourItinerary.errors.get("room_type") }}
													</span>
													<v-autocomplete
														density="compact"
														variant="outlined"
														rounded="0"
														return-object
														placeholder="Select Room Type"
														:items="this.infiniteRooms.data"
														v-model="tourItinerary.room_type"
														item-title="name"
														item-value="id"
														id="room_type"
													>
													</v-autocomplete>
												</div>
											</div>
										</div>
										<div class="row">
											<div class="col-md-4">
												<div class="mb-3">
													<label for="boat_id" class="form-label"
														><span
															v-if="tourItinerary.errors.has('boat_id')"
															class="text-danger text-lowercase"
														>
															{{ tourItinerary.errors.get("boat_id") }} </span
														><span v-else>Boat Ride</span></label
													>
													<v-autocomplete
														density="compact"
														variant="outlined"
														rounded="0"
														return-object
														placeholder="Select Boat Ride"
														:items="this.infiniteBoats.data"
														v-model="tourItinerary.boat_id"
														item-title="name"
														item-value="id"
														id="boat_id"
													>
													</v-autocomplete>
												</div>
											</div>
											<div class="col-md-4">
												<div class="mb-3">
													<label for="flight_id" class="form-label"
														><span
															v-if="tourItinerary.errors.has('flight_id')"
															class="text-danger text-lowercase"
														>
															{{ tourItinerary.errors.get("flight_id") }} </span
														><span v-else>Flight Option</span></label
													>
													<v-autocomplete
														density="compact"
														variant="outlined"
														rounded="0"
														return-object
														placeholder="Select Required Flight"
														:items="this.infiniteFlights.data"
														v-model="tourItinerary.flight_id"
														item-title="name"
														item-value="id"
														id="flight_id"
													>
													</v-autocomplete>
												</div>
											</div>
											<div class="col-md-4">
												<div class="mb-3">
													<label for="vehicle_id" class="form-label"
														><span
															v-if="tourItinerary.errors.has('vehicle_id')"
															class="text-danger text-lowercase"
														>
															{{
																tourItinerary.errors.get("vehicle_id")
															}} </span
														><span v-else>Vehicle</span></label
													>
													<v-autocomplete
														density="compact"
														variant="outlined"
														rounded="0"
														return-object
														placeholder="Select Required Vehicle"
														:items="this.infiniteVehicles.data"
														v-model="tourItinerary.vehicle_id"
														item-value="id"
														item-title="vehicle_type"
														id="vehicle_id"
													>
													</v-autocomplete>
												</div>
											</div>
										</div>
										<div class="row d-none">
											<div class="col-md-4">
												<div class="mb-3">
													<label for="accommodation_id" class="form-label"
														>Accomodation Options:</label
													>
												</div>
											</div>
										</div>
										<div class="row mt-1">
											<div class="col-md-12">
												<label for="additional_information" class="form-label"
													>Additional Information</label
												>
												<span
													v-if="
														tourItinerary.errors.has('additional_information')
													"
													class="text-danger text-lowercase"
												>
													{{
														tourItinerary.errors.get("additional_information")
													}}
												</span>
												<v-textarea
													density="compact"
													variant="outlined"
													rounded="0"
													rows="5"
													placeholder="Itinerary Additional Information"
													v-model="tourItinerary.additional_information"
													id="additional_information"
												></v-textarea>
											</div>
										</div>
									</div>
								</div>
								<!-- end of modal body -->
							</div>
						</v-card-text>

						<!-- Footer with Action Buttons -->
						<v-card-actions>
							<v-spacer>
								<!-- end of modal body -->
								<div
									class="justify-content-start modal-footer"
									style="font-family: HeaderCustomFont"
								>
									<button
										:disabled="!currentRoute"
										type="submit"
										class="btn bg-green-custom text-white w-10 m-2"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Save Itinerary
									</button>
									<button
										type="button"
										class="btn bg-danger text-white w-10 m-2"
										@click="closeModal('itinerary')"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Close
									</button>
								</div>
							</v-spacer>
						</v-card-actions>
					</form>
				</v-card>
			</v-dialog>

			<v-dialog v-model="boatsModal" max-width="1000px" persistent>
				<v-card>
					<form
						@submit.prevent="
							editMode
								? manageBoats(this.tourBoats, 'update')
								: manageBoats(this.tourBoats, 'insert')
						"
					>
						<v-card-title class="d-flex justify-space-between align-center">
							<div class="modal-header">
								<!-- <slot name="header">default header</slot> -->
								<h5
									class="modal-title font-size-20 text-dark"
									style="font-family: HeaderCustomFont"
								>
									<font-awesome-icon icon="fas fa-handshake" />&nbsp;&nbsp;Tour
									Boats
								</h5>
							</div>
							<v-icon @click="closeModal('boats')">mdi-close</v-icon>
						</v-card-title>
						<!-- Dialog Content -->
						<v-card-text>
							<div class="modal-body p-4">
								<div
									id="preloader d-none"
									class="col-sm-2 p-5"
									v-if="this.processing"
								>
									<div id="status">
										<div class="spinner-chase text-start">
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
										</div>
									</div>
								</div>
								<div class="text-start">
									<div class="row mt-1">
										<div class="col-md-8 required">
											<label for="name" class="form-label"
												><span
													v-if="tourBoats.errors.has('boat_id')"
													class="text-danger text-lowercase"
												>
													{{ tourBoats.errors.get("boat_id") }} </span
												><span v-else>Select Boat</span></label
											>
											<v-autocomplete
												density="compact"
												variant="outlined"
												rounded="0"
												clearable
												return-object
												placeholder="Select Boat"
												:items="this.infiniteBoats.data"
												v-model="tourBoats.boat_id"
												item-value="id"
												item-title="name"
												id="boat_id"
											>
											</v-autocomplete>
										</div>
										<div class="col-md-2 required">
											<label for="name" class="form-label"
												><span
													v-if="tourBoats.errors.has('pax')"
													class="text-danger text-lowercase"
												>
													{{ tourBoats.errors.get("pax") }} </span
												><span v-else>Pax</span></label
											>
											<v-text-field
												density="compact"
												variant="outlined"
												rounded="0"
												clearable
												placeholder="Number of Pax"
												v-model="tourBoats.pax"
												id="pax"
											></v-text-field>
										</div>
									</div>
									<div class="row mt-1">
										<div class="col-md-4 required">
											<div class="">
												<label for="date" class="form-label"
													><span
														v-if="tourBoats.errors.has('date')"
														class="text-danger text-lowercase"
													>
														{{ tourBoats.errors.get("date") }} </span
													><span v-else>Activity Date</span></label
												>

												<v-autocomplete
													density="compact"
													variant="outlined"
													rounded="0"
													return-object
													placeholder="Select Activity Day"
													:items="this.tourDays.data"
													v-model="tourBoats.date"
													item-title="Title"
													item-value="Day"
												>
												</v-autocomplete>
											</div>
										</div>
										<div class="col-md-3 required">
											<div class="">
												<label for="name" class="form-label"
													><span
														v-if="tourBoats.errors.has('booking_date')"
														class="text-danger text-lowercase"
													>
														{{ tourBoats.errors.get("booking_date") }} </span
													><span v-else>Booking Date</span></label
												>
												<v-text-field
													density="compact"
													variant="outlined"
													rounded="0"
													type="date"
													clearable
													placeholder="Booking Date"
													v-model="tourBoats.booking_date"
													id="booking_date"
													class="mb-0"
												></v-text-field>
											</div>
										</div>
										<div class="col-md-3 required">
											<div class="">
												<label for="name" class="form-label"
													><span
														v-if="tourBoats.errors.has('confirmation_date')"
														class="text-danger text-lowercase"
													>
														{{
															tourBoats.errors.get("confirmation_date")
														}} </span
													><span v-else>Confirmation Date</span></label
												>
												<v-text-field
													density="compact"
													variant="outlined"
													rounded="0"
													type="date"
													clearable
													placeholder="Confirmation Date"
													v-model="tourBoats.confirmation_date"
													id="confirmation_date"
													class="mb-0"
												></v-text-field>
											</div>
										</div>
									</div>
								</div>
							</div>
						</v-card-text>

						<!-- Footer with Action Buttons -->
						<v-card-actions>
							<v-spacer>
								<!-- end of modal body -->
								<div
									class="justify-content-start modal-footer"
									style="font-family: HeaderCustomFont"
								>
									<button
										:disabled="!currentRoute"
										type="submit"
										class="btn bg-green-custom text-white w-10 m-2"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Save
									</button>
									<button
										type="button"
										class="btn bg-danger text-white w-10 m-2"
										@click="closeModal('boats')"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Close
									</button>
								</div>
							</v-spacer>
							<!-- <v-btn color="primary" @click="tourModal = false">Close</v-btn> -->
						</v-card-actions>
					</form>
				</v-card>
			</v-dialog>

			<v-dialog v-model="flightsModal" max-width="1000px" persistent>
				<v-card>
					<form
						@submit.prevent="
							editMode
								? manageFlights(this.tourFlights, 'update')
								: manageFlights(this.tourFlights, 'insert')
						"
					>
						<v-card-title class="d-flex justify-space-between align-center">
							<div class="modal-header">
								<!-- <slot name="header">default header</slot> -->
								<h5
									class="modal-title font-size-20 text-dark"
									style="font-family: HeaderCustomFont"
								>
									<font-awesome-icon icon="fas fa-handshake" />&nbsp;&nbsp;Tour
									Flights
								</h5>
							</div>
							<v-icon @click="closeModal('flights')">mdi-close</v-icon>
						</v-card-title>
						<!-- Dialog Content -->
						<v-card-text>
							<div class="modal-body p-4">
								<div
									id="preloader d-none"
									class="col-sm-2 p-5"
									v-if="this.processing"
								>
									<div id="status">
										<div class="spinner-chase text-start">
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
										</div>
									</div>
								</div>
								<div class="text-start">
									<div class="row mt-1">
										<div class="col-md-7 required">
											<label for="name" class="form-label"
												><span
													v-if="tourFlights.errors.has('flight_id')"
													class="text-danger text-lowercase"
												>
													{{ tourFlights.errors.get("flight_id") }} </span
												><span v-else>Select Flight</span></label
											>
											<v-autocomplete
												density="compact"
												variant="outlined"
												rounded="0"
												clearable
												return-object
												placeholder="Select Flight"
												:items="this.infiniteFlights.data"
												v-model="tourFlights.flight_id"
												item-value="id"
												item-title="name"
												id="flight_id"
											>
											</v-autocomplete>
										</div>
										<div class="col-md-2 required">
											<label for="name" class="form-label"
												><span
													v-if="tourFlights.errors.has('pax')"
													class="text-danger text-lowercase"
												>
													{{ tourFlights.errors.get("pax") }} </span
												><span v-else>Pax</span></label
											>
											<v-text-field
												density="compact"
												variant="outlined"
												rounded="0"
												clearable
												placeholder="Number of Pax"
												v-model="tourFlights.pax"
												id="pax"
											></v-text-field>
										</div>
										<div class="col-md-3 required">
											<div class="">
												<label for="date" class="form-label"
													><span
														v-if="tourFlights.errors.has('date')"
														class="text-danger text-lowercase"
													>
														{{ tourFlights.errors.get("date") }} </span
													><span v-else>Day Number</span></label
												>

												<v-autocomplete
													density="compact"
													variant="outlined"
													rounded="0"
													return-object
													placeholder="Select Activity Day"
													:items="this.tourDays.data"
													v-model="tourFlights.date"
													item-title="Title"
													item-value="Day"
												>
												</v-autocomplete>
											</div>
										</div>
									</div>
									<div class="row mt-1">
										<div class="col-md-3 required">
											<div class="">
												<label for="name" class="form-label"
													><span
														v-if="tourFlights.errors.has('booking_date')"
														class="text-danger text-lowercase"
													>
														{{ tourFlights.errors.get("booking_date") }} </span
													><span v-else>Booking Date</span></label
												>
												<v-text-field
													density="compact"
													variant="outlined"
													rounded="0"
													type="date"
													clearable
													placeholder="Booking Date"
													v-model="tourFlights.booking_date"
													id="booking_date"
													class="mb-0"
												></v-text-field>
											</div>
										</div>
										<div class="col-md-3 required">
											<div class="">
												<label for="name" class="form-label"
													><span
														v-if="tourFlights.errors.has('confirmation_date')"
														class="text-danger text-lowercase"
													>
														{{
															tourFlights.errors.get("confirmation_date")
														}} </span
													><span v-else>Confirmation Date</span></label
												>
												<v-text-field
													density="compact"
													variant="outlined"
													rounded="0"
													type="date"
													clearable
													placeholder="Confirmation Date"
													v-model="tourFlights.confirmation_date"
													id="confirmation_date"
													class="mb-0"
												></v-text-field>
											</div>
										</div>
										<div class="col-md-2 required">
											<label for="name" class="form-label"
												><span
													v-if="tourFlights.errors.has('departure_time')"
													class="text-danger text-lowercase"
												>
													{{ tourFlights.errors.get("departure_time") }} </span
												><span v-else>Departure Time</span></label
											>
											<v-text-field
												density="compact"
												variant="outlined"
												rounded="0"
												type="time"
												clearable
												placeholder="Departure Time"
												v-model="tourFlights.departure_time"
												id="departure_time"
												class="mb-0"
											></v-text-field>
										</div>
										<div class="col-md-2 required">
											<label for="name" class="form-label"
												><span
													v-if="tourFlights.errors.has('arrival_time')"
													class="text-danger text-lowercase"
												>
													{{ tourFlights.errors.get("arrival_time") }} </span
												><span v-else>Arrival Time</span></label
											>
											<v-text-field
												density="compact"
												variant="outlined"
												rounded="0"
												type="time"
												clearable
												placeholder="Arrival Time"
												v-model="tourFlights.arrival_time"
												id="arrival_time"
												class="mb-0"
											></v-text-field>
										</div>
									</div>
									<div class="row mt-1"></div>
								</div>
							</div>
						</v-card-text>

						<!-- Footer with Action Buttons -->
						<v-card-actions>
							<v-spacer>
								<!-- end of modal body -->
								<div
									class="justify-content-start modal-footer"
									style="font-family: HeaderCustomFont"
								>
									<button
										:disabled="!currentRoute"
										type="submit"
										class="btn bg-green-custom text-white w-10 m-2"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Save
									</button>
									<button
										type="button"
										class="btn bg-danger text-white w-10 m-2"
										@click="closeModal('flights')"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Close
									</button>
								</div>
							</v-spacer>
							<!-- <v-btn color="primary" @click="tourModal = false">Close</v-btn> -->
						</v-card-actions>
					</form>
				</v-card>
			</v-dialog>

			<v-dialog v-model="previewModal" max-width="1250px" persistent>
				<v-card>
					<v-card-title class="d-flex justify-space-between align-center">
						<div class="modal-header">
							<h5
								class="modal-title font-size-20 text-dark"
								style="font-family: HeaderCustomFont"
							>
								<font-awesome-icon
									icon="fa-solid fa-print"
								/>&nbsp;&nbsp;Booking Form
							</h5>
						</div>
						<v-icon @click="closeModal('preview')">mdi-close</v-icon>
					</v-card-title>

					<v-card-text class="pa-4">
						<div
							v-if="pdfLoading"
							class="d-flex justify-center align-center"
							style="height: 650px"
						>
							<div class="text-center">
								<div class="spinner-border text-primary" role="status">
									<span class="visually-hidden">Generating PDF...</span>
								</div>
								<p class="mt-3">Generating document...</p>
							</div>
						</div>
						<div v-else class="overflow-y-auto" style="height: 650px">
							<iframe
								v-if="pdfDocument !== ''"
								:src="pdfDocument"
								width="100%"
								height="650px"
								style="border: none"
							></iframe>
							<div v-else class="text-center text-muted pt-10">
								No document to display.
							</div>
						</div>
					</v-card-text>

					<v-card-actions>
						<v-spacer></v-spacer>
						<div
							class="justify-content-start modal-footer"
							style="font-family: HeaderCustomFont"
						>
							<a
								v-if="pdfDocument !== ''"
								:href="pdfDocument"
								:download="`booking_form_${selectedForm?.reference_number}.pdf`"
								class="btn bg-green-custom text-white w-10 m-2"
							>
								<i class="fas fa-download"></i>&nbsp;&nbsp;Download
							</a>
							<button
								type="button"
								class="btn bg-danger square-button text-white w-10 m-2"
								@click="closeModal('preview')"
							>
								Close
							</button>
						</div>
					</v-card-actions>
				</v-card>
			</v-dialog>
		</div>
	</content>
</template>

<script>
import config from "../../config/settings.js";
import { Errors, Form } from "vform";

export default {
	components: {},
	data() {
		return {
			api: config.API_URL,
			prefix: config.API_PFX,
			message: "",
			http_code: "",
			selectedForm: null,
			user: [],
			messages: [],
			messageNumber: 0,
			editMode: false,
			tourModal: false,
			guestModal: false,
			touristModal: false,
			accomodationModal: false,
			activityModal: false,
			itineraryModal: false,
			pricingModal: false,
			optionalModal: false,
			flightsModal: false,
			boatsModal: false,
			includesModal: false,
			feedbackModal: false,
			logModal: false,
			previewModal: false,
			pdfDocument: "",
			pdfLoading: false,
			loadModalData: false,
			tourData: false,
			guestData: false,
			infiniteAgents: [],
			infiniteGenders: ["male", "female"],
			infiniteCountries: [],
			infiniteNationality: [],
			infiniteActivity: [],
			infiniteAccomodations: [],
			infiniteMeals: [],
			infiniteItems: [],
			infiniteRooms: [],
			infiniteItineraryz: [],
			infiniteTourists: [],
			infiniteBoats: [],
			infiniteFlights: [],
			infiniteParks: [],
			infiniteVehicles: [],
			infiniteDistricts: [],
			infiniteTowns: [],
			tourDays: [],
			filterForms: new Form({
				start: null,
				end: null,
				tour: null,
			}),

			tourGuest: new Form({
				id: "",
				guest_id: null,
				name: "",
				tour_id: "",
				country_id: "",
				arrival_info: "",
				departure_info: "",
				total_cost: "",
				deleted_at: "",
				created_at: "",
				updated_at: "",
			}),
			touristRegister: new Form({
				id: "",
				name: "",
				country_id: null,
				dob: "",
				gender: null,
				passport_no: "",
				deleted_at: "",
				created_by: "",
				created_at: "",
				updated_by: "",
				updated_at: "",
			}),
			tourAccomodation: new Form({
				id: "",
				tour_id: "",
				lodge_id: null,
				room_type: null,
				room_no: "",
				meal_plan_id: null,
				no_nights: "",
				check_in: "",
				check_out: "",
				check_in_day: "",
				check_out_day: "",
				booking_date: "",
				confirmation_date: "",
				deleted_at: "",
				created_by: "",
				updated_by: "",
				comment: "",
			}),
			tourActivity: new Form({
				id: "",
				activity_title: "",
				tour_id: "",
				activity_id: "",
				tour_checklist_id: "",
				day_number: null,
				date: "",
				itinerary_id: "",
				pax: "",
				additional_information: "",
				deleted_at: "",
				created_by: "",
				created_at: "",
				updated_by: "",
				updated_at: "",
			}),
			tourItinerary: new Form({
				id: "",
				tour_id: null,
				accommodation_id: null,
				boat_id: null,
				flight_id: null,
				vehicle_id: null,
				park_id: null,
				district_id: null,
				town_id: null,

				activity_date: "",
				additional_information: "",
				created_by: "",
				day_number: null,
				deleted_at: "",
				destination: "",
				distance: "",
				distance_unit: null,
				flight_time: "",
				high_lodge: null,
				itinerary: "",
				itinerary_activity: "",
				itinerary_item: null,
				itinerary_title: "",
				luxury_lodge: null,
				meal_plan_id: null,
				medium_lodge: null,
				room_type: null,
				transit_time: "",
				transit_unit: null,
				transit_method: null,
				updated_by: "",
				upper_lodge: null,
			}),
			tourFlights: new Form({
				id: "",
				tour_id: null,
				flight_id: null,
				pax: "",
				day_number: null,
				date: "",
				day: "",
				departure_time: "",
				arrival_time: "",
				booking_date: "",
				confirmation_date: "",
				deleted_at: "",
				created_at: "",
				created_by: "",
				updated_at: "",
				updated_by: "",
				company: "",
			}),
			tourBoats: new Form({
				id: "",
				tour_id: null,
				boat_id: null,
				pax: "",
				day_number: null,
				date: "",
				day: "",
				booking_date: "",
				confirmation_date: "",
				deleted_at: "",
				created_at: "",
				created_by: "",
				updated_at: "",
				updated_by: "",
			}),
			tours: [],
			searchForms: "",
			formsPerPage: 10,
			bookingForms: [],
			formHeaders: [
				{ title: "#", value: "index", sortable: true },
				{ title: "Ref No", value: "reference_number", sortable: true },
				{ title: "Booking Name", value: "client", sortable: true },
				{ title: "Agent", value: "agent_name", sortable: true },
				{ title: "Language", value: "guide_language", sortable: true },
				{ title: "Start", value: "from", sortable: true },
				{ title: "End", value: "to", sortable: true },
				{ title: "Permit Status", value: "permit_status", sortable: true },
				// { title: "Pax", value: "pax", sortable: true },
				// { title: "Tracking", value: "tracking", sortable: true },
				// { title: "actions", value: "actions", sortable: true },
			],
			searchGuests: "",
			guestsPerPage: 10,
			guests: [],
			guestsHeaders: [
				{ title: "#", value: "id", sortable: true },
				{ title: "Guest", value: "name", sortable: true },
				{ title: "Country", value: "country_id", sortable: true },
				// { title: "DOB", value: "dob", sortable: true },
				// { title: "Gender", value: "gender", sortable: true },
				{ title: "Passport", value: "passport", sortable: true },
				{ title: "Arrival Info", value: "arrival_info", sortable: true },
				{ title: "Departure Info", value: "departure_info", sortable: true },
				// { title: "Total", value: "total_cost", sortable: true },
				{ title: "actions", value: "actions", sortable: true },
			],

			searchAccomodation: "",
			accomodationPerPage: 10,
			accomodations: [],
			accomodationsHeaders: [
				{ title: "#", value: "index", sortable: true },
				{ title: "Name", value: "name", sortable: true },
				{ title: "Nights", value: "no_nights", sortable: true },
				{ title: "Room Type", value: "room_no", sortable: true },
				// { title: "Room No", value: "room_no", sortable: true },
				{ title: "Meals", value: "meal", sortable: true },
				{ title: "Check In", value: "check_in_out", sortable: true },
				// { title: "Check Out", value: "check_out", sortable: true },
				// { title: "Booking", value: "book_confirm", sortable: true },
				// { title: "Confirmation", value: "confirmation_date", sortable: true, },
				// { title: "Comments", value: "comments", sortable: true },
				{ title: "Actions", value: "actions", sortable: false },
			],
			searchActivity: "",
			activityPerPage: 10,
			activities: [],
			activityHeaders: [
				{ title: "#", value: "index", sortable: true },
				{ title: "Day", value: "day_number", sortable: true },
				{ title: "Activity", value: "itinerary_title", sortable: true },
				{ title: "Pax", value: "pax", sortable: true },
				{ title: "Destination", value: "destination", sortable: true },
				{ title: "Lodge", value: "Lodge", sortable: true },
				{ title: "Actions", value: "actions", sortable: false },
			],
			searchFlight: "",
			flightPerPage: 10,
			flights: [],
			flightHeaders: [
				{ title: "#", value: "index", sortable: true },
				{ title: "Flight", value: "flight", sortable: true },
				{ title: "Pax", value: "pax", sortable: true },
				{ title: "Date", value: "date", sortable: true },
				{ title: "Depart/Arrive ", value: "booking", sortable: true },
				{ title: "Confirmation", value: "confirmation", sortable: true },
				{ title: "actions", value: "actions", sortable: true },
				// { title: "Company", value: "company", sortable: true },
				// { title: "Departure", value: "departure", sortable: true },
				// { title: "Arrival", value: "arrival", sortable: true },
			],
			searchBoats: "",
			boatsPerPage: 10,
			boats: [],
			boatsHeaders: [
				{ title: "#", value: "", sortable: true },
				{ title: "Boat", value: "boat", sortable: true },
				{ title: "Pax", value: "pax", sortable: true },
				{ title: "Date", value: "date", sortable: true },
				{ title: "Booking", value: "booking", sortable: true },
				{ title: "Confirmation", value: "confirmation", sortable: true },
				{ title: "actions", value: "actions", sortable: true },
			],
			openPanels: {
				tourGuests: [0],
				tourAccomodation: [0],
				tourActivity: [0],
				tourPricing: [0],
				optionalCosts: [0],
				tourFlights: [0],
				tourBoats: [0],
			},
		};
	},
	computed: {
		currentRoute() {
			return this.$route.path.includes("/reservations/");
		},
		formsComputed() {
			if (this.bookingForms && this.bookingForms.data) {
				return this.bookingForms.data.map((form, index) => {
					form.index = index;
					return form;
				});
			}
		},
		guestsComputed() {
			if (this.guests && this.guests.data) {
				return this.guests.data.map((guest, index) => {
					guest.index = index;
					return guest;
				});
			}
		},
		activityComputed() {
			if (this.activities && this.activities.data) {
				return this.activities.data.map((activity, index) => {
					activity.index = index;
					return activity;
				});
			}
		},
		accomodationComputed() {
			if (this.accomodations && this.accomodations.data) {
				return this.accomodations.data.map((accomodation, index) => {
					accomodation.index = index;
					return accomodation;
				});
			}
		},
		flightsComputed() {
			if (this.flights && this.flights.data) {
				return this.flights.data.map((flight, index) => {
					flight.index = index;
					return flight;
				});
			}
		},
		boatsComputed() {
			if (this.boats && this.boats.data) {
				return this.boats.data.map((boat, index) => {
					boat.index = index;
					return boat;
				});
			}
		},
		tourSelect() {
			return (item) => {
				if (item && item.reference_number && item.client && item.agent_name) {
					return (
						item.reference_number + " (" + item.client + ") " + item.agent_name
					);
				}
			};
		},
	},
	methods: {
		selectItem(item) {
			// console.log(item);
			this.tourItinerary.itinerary_title = this.capitalizeWords(item.title);
			this.tourItinerary.destination = this.capitalizeWords(item.destination);
			this.tourItinerary.additional_information = this.sentenceCase(
				item.description
			);
		},
		async generateBooking() {
			this.pdfLoading = true;
			try {
				const selectedTour = JSON.parse(
					sessionStorage.getItem("selected_tour")
				);
				const logo = await this.imageBase64("/images/speke_banner_black.png");
				const pdfUrl = await this.generateBookingForm(
					// tourItineraries, selectedTour, tourGuests, tourLodges, tourBoats, tourFlights, tourPermits, logoImage
					this.activities.data,
					selectedTour,
					this.guests.data,
					this.accomodations.data,
					this.boats.data,
					this.flights.data,
					null,
					logo
				);
				this.pdfDocument = pdfUrl;
			} catch (error) {
				console.error("Booking Form Generation Error:", error);
				this.showError("Failed to generate booking form");
			} finally {
				this.pdfLoading = false;
			}
		},
		selectGuest(item) {
			// console.log(item);
			this.tourGuest.name = this.capitalizeWords(item.name);
		},
		async checkLogin() {
			var user_id = localStorage.getItem("user_id");
			var auth = localStorage.getItem("auth");

			if (auth == null || user_id == null) {
				this.$router.push("/");
				this.logout();
				this.$swal({
					text: "Session time out",
					icon: "error",
					position: "bottom-end",
					background: "#E74C3C",
					timer: 7500,
				});
			} else {
				let api = this.api + this.prefix + "/check";
				const query = await this.getData(api);
				if (query.result == "success") {
					this.message = query.response.message;
					this.http_code = query.code;
					// perform other actions
					if (user_id !== null && auth !== null) {
						this.$router.push("/dash");
					}
				}

				if (query.result == "fail") {
					this.message = query.response.message;
					this.http_code = query.code;
					if (this.http_code == 503) {
						this.$swal({
							text: "Error " + this.http_code + ": " + this.message,
							icon: "error",
							position: "bottom-end",
							background: "#E74C3C",
						});
					}

					localStorage.clear();
					sessionStorage.clear();
				}
			}
		},
		async authUser() {
			var user_id = localStorage.getItem("user_id");
			var auth = localStorage.getItem("auth");

			if (user_id !== null && auth !== null) {
				var api = this.api + this.prefix + "/user/" + user_id;
				const query = await this.getData(api);
				if (query.result == "success") {
					this.message = query.response.message;
					this.http_code = query.code;
					this.user = query.response.data;
					this.user_department = this.user.Department_id;
					localStorage.setItem("user_department", this.user.Department_id);
					localStorage.setItem("user_directorate", this.user.Directorate_id);
					localStorage.setItem(
						"selected_directorate",
						this.user.Directorate_id
					);
				} else {
					this.message = query.response.message;
					this.http_code = query.code;
					this.$swal({
						text: "Error " + this.http_code + ": " + this.message,
						icon: "error",
						position: "bottom-end",
						background: "#E74C3C",
						timer: 7500,
					});
					this.$router.push("/");
				}
			}
		},
		async openModal(modal, mode) {
			// Show loading indicator
			this.loadModalData = true;

			try {
				// Lazy load tour modal data only when needed
				if (
					(modal == "accomodation" ||
						modal == "itinerary" ||
						modal == "flights" ||
						modal == "boats") &&
					!this.tourData
				) {
					this.tourData = true;
					await Promise.all([
						this.getInfinites("agents"),
						this.getInfinites("boats"),
						this.getInfinites("days"),
						this.getInfinites("districts"),
						this.getInfinites("expected"),
						this.getInfinites("flights"),
						this.getInfinites("items"),
						this.getInfinites("lodge"),
						this.getInfinites("meal"),
						this.getInfinites("parks"),
						this.getInfinites("rooms"),
						this.getInfinites("vehicle-types"),
					]);
				}

				// Lazy load guest modal data only when needed
				if (modal == "guest" && !this.guestData) {
					this.guestData = true;

					await Promise.all([
						this.getInfinites("tourists"),
						this.getInfinites("country"),
					]);
				}
			} catch (error) {
				console.error("Error loading modal data:", error);
			} finally {
				// Hide loading indicator
				this.loadModalData = false;
			}

			let user_id = sessionStorage.getItem("user_id");
			if (modal == "guest") {
				this.tourGuest.tour_id = this.selectedForm.tour_id;
				if (mode == "update") {
					this.tourGuest.updated_by = user_id;
					this.editMode = true;
					this.guestModal = true;
				} else {
					this.tourGuest.created_by = user_id;
					this.editMode = false;
					this.guestModal = true;
				}
			} else if (modal == "tourist") {
				if (mode == "update") {
					this.touristRegister.updated_by = user_id;
					this.editMode = true;
					this.touristModal = true;
					this.guestModal = false;
				} else {
					this.touristRegister.created_by = user_id;
					this.editMode = false;
					this.touristModal = true;
					this.guestModal = false;
				}
			} else if (modal == "accomodation") {
				this.tourAccomodation.tour_id = this.selectedForm.tour_id;
				if (mode == "update") {
					this.tourAccomodation.updated_by = user_id;
					this.editMode = true;
					this.accomodationModal = true;
				} else {
					this.tourAccomodation.created_by = user_id;
					this.editMode = false;
					this.accomodationModal = true;
				}
			} else if (modal == "activity") {
				if (this.selectedForm == null) {
					this.showMessage("Please select a tour");
				} else {
					this.getInfinites("days");
					this.tourActivity.tour_id = this.selectedForm.tour_id;
					if (mode == "update") {
						this.tourActivity.updated_by = user_id;
						this.editMode = true;
						this.activityModal = true;
					} else {
						this.tourActivity.created_by = user_id;
						this.editMode = false;
						this.activityModal = true;
					}
				}
			} else if (modal == "itinerary") {
				if (this.selectedForm == null) {
					this.showMessage("Please select a tour");
				} else {
					// this.getInfinites("days");
					this.tourItinerary.tour_id = this.selectedForm.tour_id;
					if (mode == "update") {
						this.tourItinerary.updated_by = user_id;
						this.editMode = true;
						this.itineraryModal = true;
					} else {
						// this.tourItinerary.tour_id = this.selectedTour.id;
						this.tourItinerary.created_by = user_id;
						this.editMode = false;
						this.itineraryModal = true;
					}
				}
			} else if (modal == "flights") {
				if (this.selectedForm == null) {
					this.showMessage("Please select a tour");
				} else {
					// this.getInfinites("days");
					// this.getInfinites("expected");
					this.tourFlights.tour_id = this.selectedForm.tour_id;
					if (mode == "update") {
						this.tourFlights.updated_by = user_id;
						this.editMode = true;
						this.flightsModal = true;
					} else {
						this.tourFlights.created_by = user_id;
						this.editMode = false;
						this.flightsModal = true;
					}
				}
			} else if (modal == "boats") {
				if (this.selectedForm == null) {
					this.showMessage("Please select a tour");
				} else {
					// this.getInfinites("days");
					// this.getInfinites("expected");
					this.tourBoats.tour_id = this.selectedForm.tour_id;
					if (mode == "update") {
						this.tourBoats.updated_by = user_id;
						this.editMode = true;
						this.boatsModal = true;
					} else {
						this.tourBoats.created_by = user_id;
						this.editMode = false;
						this.boatsModal = true;
					}
				}
			} else if (modal == "preview") {
				if (this.selectedForm == null) {
					this.showMessage("Please select a form");
				} else {
					this.pdfDocument = "";
					this.previewModal = true;
					await this.generateBooking();
				}
			}
		},
		closeModal(modal) {
			if (modal == "guest") {
				this.editMode = false;
				this.guestModal = false;
				this.tourGuest.reset();
				this.tourGuest.errors.clear();
			} else if (modal == "tourist") {
				this.editMode = false;
				this.touristModal = false;
				this.guestModal = true;
				this.touristRegister.reset();
				this.touristRegister.errors.clear();
				this.getInfinites("tourists");
			} else if (modal == "accomodation") {
				this.editMode = false;
				this.accomodationModal = false;
				this.tourAccomodation.reset();
				this.tourAccomodation.errors.clear();
			} else if (modal == "activity") {
				this.editMode = false;
				this.activityModal = false;
				this.tourActivity.reset();
				this.tourActivity.errors.clear();
			} else if (modal == "itinerary") {
				this.editMode = false;
				this.itineraryModal = false;
				this.tourItinerary.reset();
				this.tourItinerary.errors.clear();
			} else if (modal == "flights") {
				this.editMode = false;
				this.flightsModal = false;
				this.tourFlights.reset();
				this.tourFlights.errors.clear();
			} else if (modal == "boats") {
				this.editMode = false;
				this.boatsModal = false;
				this.tourBoats.reset();
				this.tourBoats.errors.clear();
			} else if (modal == "preview") {
				this.editMode = false;
				this.pdfDocument = "";
				this.previewModal = false;
			}
		},
		async getInfinites(mode) {
			var query, api;
			if (mode == "agents") {
				api = this.api + this.prefix + "/masters/agents";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					// perform other actions
					this.infiniteAgents = query.response;
				} else {
					this.showInfo(this.message, this.http_code);
				}
			} else if (mode == "country") {
				api = this.api + this.prefix + "/settings/country";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					// perform other actions
					this.infiniteCountries = query.response;
				} else {
					this.showInfo(this.message, this.http_code);
				}
			} else if (mode == "flights") {
				api = this.api + this.prefix + "/masters/flights";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					// perform other actions
					this.infiniteFlights = query.response;
				} else {
					this.showInfo(this.message, this.http_code);
				}
			} else if (mode == "boats") {
				api = this.api + this.prefix + "/masters/boats";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					// perform other actions
					this.infiniteBoats = query.response;
				} else {
					this.showInfo(this.message, this.http_code);
				}
			} else if (mode == "vehicles") {
				api = this.api + this.prefix + "/masters/vehicles";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					// perform other actions
					this.infiniteVehicles = [];
					this.infiniteVehicles = query.response;
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "vehicle-types") {
				api = this.api + this.prefix + "/masters/vehicle-types";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					// perform other actions
					this.infiniteVehicles = [];
					this.infiniteVehicles = query.response;
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "parks") {
				api = this.api + this.prefix + "/masters/parks";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					// perform other actions
					this.infiniteParks = [];
					this.infiniteParks = query.response;
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "lodge") {
				api = this.api + this.prefix + "/masters/lodge";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					// perform other actions
					this.infiniteAccomodations = query.response;
				} else {
					this.showInfo(this.message, this.http_code);
				}
			} else if (mode == "meal") {
				api = this.api + this.prefix + "/masters/meal";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					// perform other actions
					this.infiniteMeals = query.response;
				} else {
					this.showInfo(this.message, this.http_code);
				}
			} else if (mode == "activity") {
				api = this.api + this.prefix + "/masters/activitiez";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					// perform other actions
					this.infiniteActivity = query.response;
				} else {
					this.showInfo(this.message, this.http_code);
				}
			} else if (mode == "items") {
				api = this.api + this.prefix + "/masters/items";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					// perform other actions
					this.infiniteItems = query.response;
				} else {
					this.showInfo(this.message, this.http_code);
				}
			} else if (mode == "districts") {
				api = this.api + this.prefix + "/masters/districts";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					// perform other actions
					this.infiniteDistricts = [];
					this.infiniteDistricts = query.response;
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "towns") {
				api = this.api + this.prefix + "/masters/towns";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					// perform other actions
					this.infiniteTowns = [];
					this.infiniteTowns = query.response;
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "rooms") {
				api = this.api + this.prefix + "/settings/rooms";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					// perform other actions
					this.infiniteRooms = query.response;
				} else {
					this.showInfo(this.message, this.http_code);
				}
			} else if (mode == "itineraryz") {
				api = this.api + this.prefix + "/masters/itineraryz";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					// perform other actions
					this.infiniteItineraryz = query.response;
				} else {
					this.showInfo(this.message, this.http_code);
				}
			} else if (mode == "tourists") {
				api = this.api + this.prefix + "/masters/tourist";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					// perform other actions
					this.infiniteTourists = query.response;
				} else {
					this.showInfo(this.message, this.http_code);
				}
			} else if (mode == "days") {
				api =
					this.api +
					this.prefix +
					"/reservation/tour/" +
					this.selectedForm.tour_id +
					"/days";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.tourDays = query.response;
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "expected") {
				api =
					this.api +
					this.prefix +
					"/reservation/itinerary/" +
					this.selectedForm.tour_id +
					"/expected";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.expectedItinerary = query.response;
				} else {
					this.showError(this.message, this.http_code);
				}
			}
		},
		async selectForm(event) {
			//sessionStorage.removeItem("selected_form");
			//sessionStorage.setItem("selected_form", JSON.stringify(event));
			sessionStorage.removeItem("selected_tour");
			sessionStorage.setItem("selected_tour", JSON.stringify(event));
			this.tourFlights.pax = this.selectedForm.pax;
			this.tourBoats.pax = this.selectedForm.pax;
			this.selectedForm = event;
			this.showMessage("Form " + event.reference_number + " selected!");

			await this.manageGuests("None", "fetch");
			await this.manageAccomodation("None", "fetch");
			await this.manageActivity("None", "fetch");
			await this.manageFlights("None", "fetch");
			await this.manageBoats("None", "fetch");
		},

		async manageForms(event, mode) {
			var query, api;
			if (mode == "fetch") {
				let api = this.api + this.prefix + "/reservation/forms";
				const query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.bookingForms = query.response;
					if (this.selectedForm) {
						this.selectForm(this.selectedForm);
					} else {
						this.showMessage("No Form Selected");
					}
				} else {
					this.showError(this.message, this.http_code);
				}
			}
		},
		async manageTours(event, mode) {
			var query, api, selected;
			if (mode == "fetch") {
				api = this.api + this.prefix + "/reservation/tours";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					// perform other actions
					this.tours = [];
					this.tours = query.response;
					if (this.selectedTour) {
						this.selectTour(this.selectedTour);
					} else {
						this.showMessage("No Tour Selected");
					}
				} else {
					this.showError(this.message, this.http_code);
				}
			}
		},
		async manageGuests(event, mode) {
			var query, api, tour;
			if (mode == "fetch") {
				if (this.selectedForm !== null) {
					// tour = JSON.parse(sessionStorage.getItem("selected_tour"));
					api =
						this.api +
						this.prefix +
						"/reservation/guest/" +
						this.selectedForm.tour_id;
					query = await this.getData(api);
					this.message = query.response.message;
					this.http_code = query.code;
					this.guests = [];
					if (query.result == "success" && query.response.data.length > 0) {
						this.guests = query.response;
					} else {
						this.showInfo(this.message);
					}
				}
			} else if (mode == "insert") {
				let api = this.api + this.prefix + "/reservation/guest";
				const query = await this.postData(api, this.tourGuest);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.showMessage(this.message);
					this.closeModal("guest");
					this.manageGuests("None", "fetch");
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "update") {
				let api = this.api + this.prefix + "/reservation/guest/" + event.id;
				const query = await this.putData(api, this.tourGuest);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.showMessage(this.message);
					this.closeModal("guest");
					this.manageGuests("None", "fetch");
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "edit") {
				this.tourGuest.reset();
				this.tourGuest.fill(event);
				this.tourGuest.guest_id = event.guest;
				this.openModal("guest", "update");
			} else {
				let confirmation = await this.showConfirmation(
					"Delete this itinerary?"
				);
				if (confirmation.result == "Yes") {
					let api = this.api + this.prefix + "/reservation/guest/" + event.id;
					const query = await this.deleteData(api);
					this.message = query.response.message;
					this.http_code = query.code;
					if (query.result == "success") {
						this.showMessage(this.message);
						this.closeModal("boats");
						this.manageGuests("None", "fetch");
					} else {
						this.showError(this.message, this.http_code);
					}
				}
			}
		},
		async manageTourists(event, mode) {
			var query, api;
			if (mode == "insert") {
				let api = this.api + this.prefix + "/masters/tourist";
				const query = await this.postData(api, this.touristRegister);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.showMessage(this.message);
					this.closeModal("tourist");
					this.manageGuests("None", "fetch");
				} else {
					this.showError(this.message, this.http_code);
				}
			}
		},
		async manageAccomodation(event, mode) {
			var query, api;
			if (mode == "fetch") {
				if (this.selectedForm !== null) {
					// tour = JSON.parse(sessionStorage.getItem("selected_tour"));
					api =
						this.api +
						this.prefix +
						"/reservation/accomodation/" +
						this.selectedForm.tour_id;
					const query = await this.getData(api);
					this.message = query.response.message;
					this.http_code = query.code;
					this.accomodations = [];
					if (query.result == "success" && query.response.data.length > 0) {
						this.accomodations = query.response;
					} else {
						this.showInfo(this.message);
					}
				}
			} else if (mode == "insert") {
				api = this.api + this.prefix + "/reservation/accomodation";
				const query = await this.postData(api, this.tourAccomodation);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.closeModal("accomodation");
					this.manageAccomodation("None", "fetch");
					this.showMessage(this.message);
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "update") {
				api = this.api + this.prefix + "/reservation/accomodation/" + event.id;
				const query = await this.putData(api, this.tourAccomodation);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.closeModal("accomodation");
					this.manageAccomodation("None", "fetch");
					this.showMessage(this.message);
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "edit") {
				this.tourAccomodation.reset();
				this.tourAccomodation.fill(event);
				this.tourAccomodation.meal_plan_id = event.meal;
				this.tourAccomodation.lodge_id = event.lodge;
				this.tourAccomodation.room_type = event.room;
				this.tourAccomodation.check_in =
					this.tourDays.data?.find((day) => day.Day === event.check_in_day) ||
					event.check_in;
				this.tourAccomodation.check_out =
					this.tourDays.data?.find((day) => day.Day === event.check_out_day) ||
					event.check_out;
				this.openModal("accomodation", "update");
			} else {
				let confirmation = await this.showConfirmation(
					"Delete this itinerary?"
				);
				if (confirmation.result == "Yes") {
					api =
						this.api + this.prefix + "/reservation/accomodation/" + event.id;
					const query = await this.deleteData(api);
					this.message = query.response.message;
					this.http_code = query.code;
					if (query.result == "success") {
						this.closeModal("accomodation");
						this.manageAccomodation("None", "fetch");
						this.showMessage(this.message);
					} else {
						this.showError(this.message, this.http_code);
					}
				}
			}
		},
		async manageActivity(event, mode) {
			var query, api;
			if (mode == "fetch") {
				if (this.selectedForm !== null) {
					api =
						this.api +
						this.prefix +
						"/reservation/itineraries/" +
						this.selectedForm.tour_id;
					query = await this.getData(api);
					this.message = this.capitalizeWords(query.response.message);
					this.http_code = query.code;
					this.activities = [];
					if (query.result == "success" && query.response.data.length > 0) {
						this.activities = query.response;
					} else {
						this.showInfo(this.message);
					}
				}
			} else if (mode == "insert") {
				api = this.api + this.prefix + "/reservation/itineraries";
				query = await this.postData(api, this.tourItinerary);
				this.message = this.capitalizeWords(query.response.message);
				this.http_code = query.code;
				if (query.result == "success") {
					this.closeModal("itinerary");
					this.manageActivity("None", "fetch");
					this.showMessage(this.message);

					this.manageAccomodation("None", "fetch");
					this.manageFlights("None", "fetch");
					this.manageBoats("None", "fetch");
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "update") {
				api =
					this.api +
					this.prefix +
					"/reservation/itineraries/" +
					event.itinerary;
				query = await this.putData(api, this.tourItinerary);
				this.message = this.capitalizeWords(query.response.message);
				this.http_code = query.code;
				if (query.result == "success") {
					this.closeModal("itinerary");
					this.manageActivity("None", "fetch");
					this.showMessage(this.message);

					this.manageAccomodation("None", "fetch");
					this.manageFlights("None", "fetch");
					this.manageBoats("None", "fetch");
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "edit") {
				this.tourItinerary.reset();
				this.tourItinerary.fill(event);
				this.tourItinerary.accommodation_id = event.lodge;
				this.tourItinerary.itinerary_item = event.item;
				this.tourItinerary.meal_plan_id = event.tour_lodge?.meal;
				this.tourItinerary.room_type = event.tour_lodge?.room;
				this.tourItinerary.boat_id = event.boat;
				this.tourItinerary.flight_id = event.flight;
				this.tourItinerary.vehicle_id = event.vehicle;
				this.tourItinerary.park_id = event.park;
				this.tourItinerary.day_number =
					this.tourDays.data?.find((day) => day.Day === event.day_number) ||
					event.day_number;
				this.openModal("itinerary", "update");
			} else {
				let confirmation = await this.showConfirmation(
					"Delete this itinerary?"
				);
				if (confirmation.result == "Yes") {
					api =
						this.api +
						this.prefix +
						"/reservation/itineraries/" +
						event.itinerary;
					query = await this.deleteData(api);
					this.message = this.capitalizeWords(query.response.message);
					this.http_code = query.code;
					if (query.result == "success") {
						this.closeModal("itinerary");
						this.manageActivity("None", "fetch");
						this.showMessage(this.message);

						this.manageAccomodation("None", "fetch");
						this.manageFlights("None", "fetch");
						this.manageBoats("None", "fetch");
					} else {
						this.showError(this.message, this.http_code);
					}
				}
			}
		},
		async manageFlights(event, mode) {
			var query, api;
			if (mode == "fetch") {
				let api =
					this.api +
					this.prefix +
					"/reservation/flight/" +
					this.selectedForm.tour_id;
				const query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				this.flights = [];
				if (query.result == "success" && query.response.data.length > 0) {
					this.flights = query.response;
				} else {
					this.showInfo(this.message);
				}
			} else if (mode == "insert") {
				let api = this.api + this.prefix + "/reservation/flight";
				const query = await this.postData(api, this.tourFlights);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.closeModal("flights");
					this.manageFlights("None", "fetch");
					this.showMessage(this.message);
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "update") {
				let api = this.api + this.prefix + "/reservation/flight/" + event.id;
				const query = await this.putData(api, this.tourFlights);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.closeModal("flights");
					this.manageFlights("None", "fetch");
					this.showMessage(this.message);
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "edit") {
				this.tourFlights.reset();
				this.tourFlights.fill(event);
				this.tourFlights.flight_id = event.flight;
				this.tourFlights.date =
					this.tourDays.data?.find((day) => day.Day === event.day) ||
					event.date;
				this.openModal("flights", "update");
			} else {
				let confirmation = await this.showConfirmation("Delete this Flight?");
				if (confirmation.result == "Yes") {
					let api = this.api + this.prefix + "/reservation/flight/" + event.id;
					const query = await this.deleteData(api);
					this.message = query.response.message;
					this.http_code = query.code;
					if (query.result == "success") {
						this.closeModal("flights");
						this.manageFlights("None", "fetch");
						this.showMessage(this.message);
					} else {
						this.showError(this.message, this.http_code);
					}
				}
			}
		},
		async manageBoats(event, mode) {
			var query, api;
			if (mode == "fetch") {
				let api =
					this.api +
					this.prefix +
					"/reservation/boat/" +
					this.selectedForm.tour_id;
				const query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				this.boats = [];
				if (query.result == "success" && query.response.data.length > 0) {
					this.boats = query.response;
				} else {
					this.showInfo(this.message);
				}
			} else if (mode == "insert") {
				let api = this.api + this.prefix + "/reservation/boat";
				const query = await this.postData(api, this.tourBoats);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.closeModal("boats");
					this.manageBoats("None", "fetch");
					this.showMessage(this.message);
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "update") {
				let api = this.api + this.prefix + "/reservation/boat/" + event.id;
				const query = await this.putData(api, this.tourBoats);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.closeModal("boats");
					this.manageBoats("None", "fetch");
					this.showMessage(this.message);
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "edit") {
				this.tourBoats.reset();
				this.tourBoats.fill(event);
				this.tourBoats.boat_id = event.boat;
				this.tourBoats.date =
					this.tourDays.data?.find((day) => day.Day === event.day) ||
					event.date;
				this.openModal("boats", "update");
			} else {
				let confirmation = await this.showConfirmation(
					"Delete this itinerary?"
				);
				if (confirmation.result == "Yes") {
					let api = this.api + this.prefix + "/reservation/boat/" + event.id;
					const query = await this.deleteData(api);
					this.message = query.response.message;
					this.http_code = query.code;
					if (query.result == "success") {
						this.closeModal("boats");
						this.manageBoats("None", "fetch");
						this.showMessage(this.message);
					} else {
						this.showError(this.message, this.http_code);
					}
				}
			}
		},
	},
	created() {
		if (this.selectedForm == null) {
			if (sessionStorage.getItem("selected_tour") !== "") {
				let selected = JSON.parse(sessionStorage.getItem("selected_tour"));
				this.selectedForm = selected;
				this.filterForms.tour = this.selectedForm;
			}
		}

		this.manageForms("None", "fetch");
	},
	beforeMount() {},
	mounted() {},
	unmounted() {},
	beforeUnmount() {},
};
</script>



